<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Swal from "sweetalert2";
import Loader from "../components/loader";
import api from "@/axios";
import moment from "moment/moment";
import Multiselect from "@vueform/multiselect";
import VueEasyLightbox from "vue-easy-lightbox";
import DropZone from "@/components/widgets/dropZone.vue";
import {ref} from "vue";
import useVuelidate from "@vuelidate/core";
import exportFromJSON from "export-from-json";

import {
  DxTreeList,
  DxColumn,
  DxColumnChooser,
  DxHeaderFilter,
  DxSearchPanel,
  DxSelection,
  DxLookup,
  DxScrolling,
} from 'devextreme-vue/tree-list';
import {getBaseUrl} from "@/helpers/baseUrl";



export default {
  page: {
    title: "Editar Produto",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {DropZone, Layout, PageHeader, Loader, Multiselect, VueEasyLightbox,
    DxTreeList,
    DxColumn,
    DxColumnChooser,
    DxHeaderFilter,
    DxSearchPanel,
    DxSelection,
    DxLookup,
    DxScrolling,
  },
  setup() {

    let dropzoneFile = ref("");
    const drop = (e) => {
      dropzoneFile.value = e.dataTransfer.files[0]
    };

    return { dropzoneFile, drop, v$: useVuelidate()};
  },
  data() {
    return {
      incluiHistSaldoVirtual: false,
      totalSaldoEntradas: 0,
      totalSaldoSaidas: 0,
      totalSaldoLiquido: 0,

      dtIniFiltro: null,
      dtFimFiltro: null,
      submittedPeriodo: false,
      showModalPeriodo: false,

      prodVariacsData: null,
      variacoesProdData: [],
      produtoAtrVarData: null,
      produtoOpcaoVarData: 0,
      submittedVariacao: false,
      showModalCriarVariacao: false,


      prodComposData: null,
      dtlistPesqProduto: [],
      loadingPesqProd: false,
      produtoPesqCompData: null,
      produtoSelData: {},
      produtoQtdCompData: 0,
      produtoFatorCompData: '',

      submittedComposicao: false,
      showModalCriarComposicao: false,



      statuses: [
        'Ativo',
        'Inativo'
      ],
      expandedRowKeys: [1, 2],
      selectedRowKeys: [1, 29, 42],

      prodCategsData: null,

      prodcriacateg: null,
      prodcriacategpai: null,
      showModalCriarCategoria: false,

      dtListPesqCategoria: null,
      submittedCategoria: false,

      prodAuxData: {},
      prodFornecsData: null,

      optionsTags:[
        {
          'cod': 'PR',
          'desc': 'Promoção',
        },
        {
          'cod': 'TX',
          'desc': 'Toxina',
        },
      ],

      blobUrlPeq: null,
      blobUrlGrd: null,

      mediasData: null,
      erroUpImagem: '',
      optionsTipo:[
        {
          'cod': 'SE',
          'desc': 'Serviço',
        },
        {
          'cod': 'PA',
          'desc': 'Patrimônio',
        },
        {
          'cod': 'UC',
          'desc': 'Uso e Consumo',
        },
      ],
      optionsFormato:[
        {
          'cod': 'SI',
          'desc': 'Simples',
        },
        {
          'cod': 'VA',
          'desc': 'Variação',
        },
        {
          'cod': 'CO',
          'desc': 'Composição',
        },
      ],
      showModalAtuImg: false,
      submittedImagem: false,
      tipoUpload: 'peq',

      imgSmall: false,
      imgLarge: false,

      prodSaldoData: null,
      prodSaldoLocData: null,

      prodPrecosData: null,
      submittedPreco: false,
      tabPrecoData: null,
      dtListPesqTabPreco: null,
      showModalPreco: false,
      prodPrecoData: {},

      loadingRegras: false,
      fabricData: null,
      dtListPesqFabric: null,

      codFiscData: null,
      dtListPesqCodFis: null,

      classeData: null,
      dtListPesqClasse: null,
      subGrupoData: null,
      dtListPesqSubGrupo: null,
      grupoData: null,
      dtListPesqGrupo: null,
      showModalGrampo: null,
      cotacoesData: null,
      gramposData: null,
      grampoData: {

      },
      errosValid: null,
      contClickAvanc: 0,
      produtoData: {
        id: 0,
        status: 'A'
      },


      prodIcmsData: {},
      prodPisCofinsData: {},


      idData: 0,
      updating: true,
      updatingAutomacoes: false,
      activeTab: 0,
      activeTabPrinc: 0,
      submitted: false,
      submittedRobo: false,

      title: "Editar Produto",
      titleEstoque: "Estoque",
      items: [
        {
          text: "Produtos",
          href: "/produtos/list",
        },
        {
          text: "Editar Produto",
          active: true,
        },
      ],
      prodParamData: {},
      showFormProdParam: false,
      prodParam: [],

      showModalHelpLote: false,
      empresa: null,
      showModalRemanejarSaldo: false,
      itemRemanejarRead: {},
      itemRemanejarWrite: {
        endwms: null
      },
      dtlistPesqEndereco: [],
      dtListNewEndRemanejar: [],
      newEndValidado: false,

      dtListPesqEmpresa: [],
      historicoEndereco: [],
      flagDeleteProdutoSaldo: null
    };
  },

  methods: {
    deletarProdutoSaldo(data){
      console.log("deletarProdutoSaldo")
      console.log(data)

      Swal.fire({
        position: "center",
        icon: "warning",
        title: "Deseja realmente deletar registro do histórico?",
        showConfirmButton: true,
        showCancelButton: true
      }).then((confirmado) => {
        if(confirmado.isConfirmed){
          api.post(`${getBaseUrl()}api/deletarprodutosaldo`, {
            produtosaldo_id: data.id
          }).then((res) => {
            console.log('then axios remanejsaldo')
            console.log(res.data)

            if(res.data.success){
              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Registro deletado com sucesso!",
                showConfirmButton: false,
                timer: 2500
              })
            }else{
              Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Erro na deleção do registro!",
                showConfirmButton: false,
                timer: 2500
              })
            }
          }).then(() => {
            this.atualizaPagina()
          })
        }
      })
    },

    abreOsSeparacao(wmsos_id){
      console.log('abreOsSeparacao: ' + wmsos_id)

      if(wmsos_id < 1){
        Swal.fire({
          position: "top-end",
          icon: "danger",
          title: "Não existe OS!",
          showConfirmButton: false,
          timer: 2500
        })
      }

      this.$router.push(`/wmsos/saidaeditarnova/${wmsos_id}`);
    },

    confirmarRemanejo(){
      console.log('confirmarRemanejo')

      /*
      * Formatando o número
      */
      let qtdTransf = this.itemRemanejarWrite.saldo.trim()
      if (/,/.test(qtdTransf) && /\d+,\d+$/.test(qtdTransf)) {
        // remove separadores de milhar
        qtdTransf = qtdTransf.replace(/\./g, "");
        // troca vírgula decimal por ponto
        qtdTransf = qtdTransf.replace(",", ".");
      } else {
        //remove vírgulas de milhar
        qtdTransf = qtdTransf.replace(/,/g, "");
      }

      this.itemRemanejarWrite.saldo = qtdTransf


      if(this.itemRemanejarWrite.saldo > this.itemRemanejarRead.saldo){
        Swal.fire({
          position: "center",
          icon: "danger",
          title: "Quantidade a remanejar é maior que a quantidade disponível",
          showConfirmButton: false,
          timer: 2500
        })

        return
      }

      Swal.fire({
        position: "center",
        icon: "info",
        title: "Deseja realmente realizar a mudança de endereço?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(confirmed => {
        if(confirmed.isConfirmed){
          api.post(`${getBaseUrl()}api/remanejsaldoprod`, {
            itemSaldoRemaneja: this.itemRemanejarWrite
          }).then((res) => {
            console.log('then axios remanejsaldo')
            console.log(res.data)
            //console.log(JSON.stringify(res.data))

            this.showModalRemanejarSaldo = false
            this.itemRemanejarRead = {}
            this.itemRemanejarWrite = {}

            if(res.data.success){
              Swal.fire({
                position: "center",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 2500
              }).then(() => {
                this.carregarDados()
              })
            } else {
              Swal.fire({
                position: "center",
                icon: "error",
                title: res.data.message,
                showConfirmButton: false,
                timer: 2500
              }).then(() => {
                this.carregarDados()
              })
            }
          })
        }
      })
    },

    pesqEmpresa(evt){
      console.log('pesqEmpresa')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/emprepesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqEmpresa = res.data
        })
      }
    },

    validaNewEndereco(){
      console.log('validaNewEndereco')

      api.get(`${getBaseUrl()}api/dadosnovoendremanejarsaldo`, {
        params: { endwms: this.itemRemanejarWrite.endwms }
      }).then((res) => {
        this.newEndValidado = true
        console.log('then dadosnovoendremanejarsaldo')
        console.log(res.data)
        //console.log(JSON.stringify(res.data))

        if(res.data.success === true) {

          this.dtListNewEndRemanejar = res.data.data

        } else {
          Swal.fire({
            position: "center",
            icon: "error",
            title: res.data.message,
            showConfirmButton: false,
            timer: 2500
          })
        }
      })
    },

    escolheuEndereco(){
      console.log('escolheuEndereco')

      this.itemRemanejarWrite.produto_id = this.produtoData.id
      this.itemRemanejarWrite.lote = this.itemRemanejarRead.lote

      this.itemRemanejarWrite.oldEndWms = this.itemRemanejarRead.endwms
      this.itemRemanejarWrite.oldEndWmsId = this.itemRemanejarRead.id

      console.log('itemRemanejarWrite: ' + JSON.stringify(this.itemRemanejarWrite))

      this.validaNewEndereco()
    },

    pesqEndereco(evt) {
      console.log('pesqEndereco')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        api.get(`${getBaseUrl()}api/enderpes`, {
          params: { q: query, origem: "produto", origem_id: this.produtoData.id }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtlistPesqEndereco = res.data
        })
      }
    },

    remanejarSaldo(data){
      console.log('remanejarSaldo')
      console.log(JSON.stringify(data))

      this.itemRemanejarRead = data

      this.showModalRemanejarSaldo = true
    },

    deletarProdParam(prodparam_id) {
      console.log('deletarRegraFrete')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Regra de Frete",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {
          api.delete(`${getBaseUrl()}api/prodparam`, {
            params: {
              'prodparam_id': prodparam_id
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(JSON.stringify(res.data))
            
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: res.data.message,
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.carregarDados()
            })
          })
        }
      })
    },

    formataDescProdParam(parametro) {
      console.log('descricao: ' + parametro.descricao)
      if (parametro.descricao) {
        return parametro.descricao
      }

      switch (parametro.valor) {
        case 'SKIP_CONF_LOTE':
          return "Não considerar lote"
      }
    },

    confProdParam() {
      console.log('confProdParam')
      console.log(JSON.stringify(this.prodParamData))
      this.prodParamData.empresa_id = this.idData
      if (this.prodParamData.valor) {
        this.showFormEmprParam = false
        this.prodParamData.produto_id = this.idData


        this.updating = true

        api.post(`${getBaseUrl()}api/prodparam`, {
          prodParamData: this.prodParamData
        }).then((res) => {
          console.log('then axios')
          console.log(JSON.stringify(res.data))

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            //this.prodParam =res.data[0]
            this.showFormProdParam = false
            this.updating = false
            this.carregarDados()
          })
        }).catch((err) => {
          console.log('erro axios')
          console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false
          this.showFormProdParam = false
          this.carregarDados()
        })
      }
    },

    novoProdParam(){
      this.showFormProdParam = true
      this.prodParamData = {}
    },

    recontarSaldos(){
      console.log('recontarSaldos')
      this.incluiHistSaldoVirtual = !this.incluiHistSaldoVirtual

      api.post(`${getBaseUrl()}api/mudalistaprodsaldos`, {
        idData: this.idData,
        incluiVirtuais: this.incluiHistSaldoVirtual
      }).then((res) => {
        console.log('then recontarsaldosprod')
        console.log(res.data)

        this.prodSaldoData = res.data['produtosaldoList']
        this.prodSaldoLocData = res.data['produtosaldolocList']
        this.produtoData = res.data['produtoData']

        if(res.data.saldos) {
          const entradas = res.data.saldos.entradas
          const saidas = res.data.saldos.saidas

          this.calculaTotais(entradas, saidas)
        }
      })
    },

    editCompos(data){
      console.log('editCompos: ' + data.produto_id)
      console.log('editCompos: ' + data.codigo)
      console.log('editCompos: ' + data.descricao)
      console.log(data)

      this.dtListPesqProduto = [
        {
          'id': 123,
          'codigo': '456',
          'descricao': 'teste',
        }
      ]
      this.produtoPesqCompData = 'teste'


      this.showModalCriarComposicao = true
      // console.log('regSelecionado: ')
      // console.log(this.regSelecionado)
    },


    atualizaPagina() {
      window.location.reload();
    },

    exportarEstoque(){
      console.log('exportarEstoque')

      const data = this.prodSaldoData
      const fileName = "exp_estoque";
      const exportType = exportFromJSON.types.xls;
      if (data) exportFromJSON({ data, fileName, exportType });



    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      this.showModalPeriodo = false
      this.carregarDados()
    },

    mudouAtribVar(){
      console.log('mudouAtribVar')

      switch (this.produtoAtrVarData) {
        case 'Cor':
          this.variacoesProdData = [
            {
              key: 'Amarelo',
              value: 'Amarelo'
            },
            {
              key: 'Azul',
              value: 'Azul'
            },
            {
              key: 'Branco',
              value: 'Branco'
            },
            {
              key: 'Preto',
              value: 'Preto'
            },
            {
              key: 'Verde',
              value: 'Verde'
            },
            {
              key: 'Vermelho',
              value: 'Vermelho'
            },
          ]
          break

        case 'Tamanho':
          this.variacoesProdData = [
            {
              key: 'P',
              value: 'P'
            },
            {
              key: 'PP',
              value: 'PP'
            },
            {
              key: 'M',
              value: 'M'
            },
            {
              key: 'G',
              value: 'G'
            },
            {
              key: 'GG',
              value: 'GG'
            },
          ]
          break

        case 'Largura':
          this.variacoesProdData = [
            {
              key: 'P',
              value: 'P'
            },
            {
              key: 'PP',
              value: 'PP'
            },
            {
              key: 'M',
              value: 'M'
            },
            {
              key: 'G',
              value: 'G'
            },
            {
              key: 'GG',
              value: 'GG'
            },
          ]
          break

        case 'Voltagem':
          this.variacoesProdData = [
            {
              key: '110v',
              value: '110v'
            },
            {
              key: '220v',
              value: '220v'
            },
          ]
          break

      }


    },





    delCompos(idData){
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          api.delete(`${getBaseUrl()}api/prcompos`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

            this.prodComposData = res.data[0]

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })


        }
      })
    },

    delVariac(idData){
      console.log('deletar_0: ' + idData)
      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          api.delete(`${getBaseUrl()}api/prvariac`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)

            this.prodVariacsData = res.data[0]

            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })


        }
      })
    },


    criarComposicao(){
      console.log('criarComposicao')
      this.submittedComposicao = false
      this.activeTab = 0
      this.activeTabPrinc = 2
      this.produtoPesqCompData = null
      this.produtoQtdCompData = 0
      this.produtoFatorCompData = '*'
      this.showModalCriarComposicao = true
    },


    criarVariacao(){
      console.log('criarVariacao')
      this.submittedVariacao = false
      this.showModalCriarVariacao = true
      this.activeTab = 0
      this.activeTabPrinc = 1
      this.produtoAtrVarData = null
      this.produtoOpcaoVarData = 0
    },

    pesqProduto(query){
      console.log('pesqProduto')
      console.log(query)

      if (query.length > 1){
        this.loadingPesqProd = true
        api.get(`${getBaseUrl()}api/prodpesqtd`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)

          this.dtlistPesqProduto = res.data

          this.dtlistPesqProduto.forEach((value) => {
            if (value.imgs){
              let imgTrat = value.imgs.split(',')
              value.img1 = `${getBaseUrl() + '_IMG'}/peq/${imgTrat[0]}`
            }
          })

          if( this.dtlistPesqProduto?.length === 1 &&
            (
                this.dtlistPesqProduto[0]?.codigo === query ||
                this.dtlistPesqProduto[0]?.codbarra === query ||
                this.dtlistPesqProduto[0]?.descricao === query
            )
          ){
            this.produtoPesqCompData = this.dtlistPesqProduto[0].id
            this.escolheuProduto()
            this.$nextTick(() => {
              if(this.$refs.inputPesqProd?.deactivate){
                this.$refs.inputPesqProd?.deactivate()
              }
            })
          }
        })
        .finally(() => {
          this.loadingPesqProd = false
        })
      }
    },


    escolheuProduto(){
      console.log('escolheuProduto')
      console.log(this.produtoPesqCompData)
      this.dtlistPesqProduto.forEach((produto) => {
        // console.log('value')
        // console.log(produto.codigo)
        if (produto.codigo === this.produtoPesqCompData) {
          console.log('produtoSel')
          console.log(produto)
          this.produtoSelData = produto
          this.produtoSelData.vlrunitbrt = produto.preco
          this.produtoSelData.qtd = 1
        }
      })
      this.$refs.qtdcompos.focus()
    },




    confNovaComposicao() {
      console.log('confNovaComposicao')
      this.submittedComposicao = true
      if (this.produtoPesqCompData && this.produtoQtdCompData > 0) {
        api.post(`${getBaseUrl()}api/prodcompos`, {
          prodid: this.idData,
          prodcompid: this.produtoPesqCompData,
          fator: this.produtoFatorCompData,
          qtd: this.produtoQtdCompData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.prodComposData = res.data[0]
          this.updating = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.showModalCriarComposicao = false
        })
      }
    },


    confNovaVariacao() {
      console.log('confNovaVariacao')
      this.submittedVariacao = true
      if (this.produtoAtrVarData && this.produtoOpcaoVarData) {
        api.post(`${getBaseUrl()}api/prodvariac`, {
          prodid: this.idData,
          atributo: this.produtoAtrVarData,
          opcao: this.produtoOpcaoVarData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.prodVariacsData = res.data[0]
          this.updating = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.showModalCriarVariacao = false
        })
      }
    },




    onRowDblClick(row) {
      console.log('onRowDblClick')
      let idData = row.key
      console.log(idData)

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Categoria " + idData + " (Produto)",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.updating = true

          api.delete(`${getBaseUrl()}api/prcateg`, {
            params: {
              'iddata': idData
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })

            this.prodCategsData = res.data[0]
            this.updating = false

          })

        }
      })


    },


    pesqCategoria(evt){
      console.log('pesqCategoria')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        // this.prodPrecoData.tabpreco = ''
        api.get(`${getBaseUrl()}api/categpesq`, {
          params: { q: query}
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCategoria = res.data
        })
      }
    },


    confNovaCategoria() {
      console.log('confNovaCategoria')
      this.submittedCategoria = true
      if (this.prodcriacateg) {
        api.post(`${getBaseUrl()}api/prodcateg`, {
          prodid: this.idData,
          categid: this.prodcriacateg,
          categpai: this.prodcriacategpai
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.prodCategsData = res.data[0]
          this.updating = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })
          this.showModalCriarCategoria = false
        })
      }
    },


    criarCategoria() {
      console.log('criarCategoria')
      this.submittedCategoria = false
      this.showModalCriarCategoria = true
      this.activeTab = 7
      this.prodcriacateg = null
      this.prodcriacategpai = null


    },


    downFile(path, nomeArq){
      console.log('downFile: ' + path)
      //console.log('downFile: ' + path.split('.').pop())
      this.loadingFiles = true
      api.get(`${getBaseUrl()}api/getfile`, {
        responseType: 'blob',
        params: { pathData: path }
      }).then((res) => {
        console.log('res down')
        console.log(res)
        var fileURL = window.URL.createObjectURL(new Blob([res.data]));
        var fileLink = document.createElement('a');
        fileLink.href = fileURL;
        fileLink.setAttribute('download', nomeArq);
        document.body.appendChild(fileLink);
        console.log('fileLink')
        console.log(fileURL)
        fileLink.click();
        this.loadingFiles = false
      })
    },


    abrirMov(dataMov) {
      console.log('abrirMov')
      console.log(dataMov)

      if (dataMov.movori === '06') {

        const routeData = this.$router.resolve(`/movcompra/editar/${dataMov.movid}`)
        window.open(routeData.href, '_blank')

      }


    },

    gerarCodigo() {
      console.log('gerarCodigo')

      api.get(`${getBaseUrl()}api/prgeracod`).then((res) => {
        console.log(res)

        this.produtoData.codigo = res.data[0]

        // console.log('then axios')
        // console.log(res.data)
        // this.carregarDados()
        // console.log(res.data.length)
        // this.dtListPesqTabPreco = res.data
      })


    },


    abrirGruposProdutos(){
      console.log('abrirGruposProdutos')
      const routeData = this.$router.resolve(`/prodgrupos/list`)
      window.open(routeData.href, '_blank')
    },

    abrirSubGruposProdutos(){
      console.log('abrirSubGruposProdutos')
      const routeData = this.$router.resolve(`/prodsubgrupos/list`)
      window.open(routeData.href, '_blank')
    },

    abrirFabricantesProdutos(){
      console.log('abrirFabricantesProdutos')
      const routeData = this.$router.resolve(`/prodfabrics/list`)
      window.open(routeData.href, '_blank')
    },

    abrirClFiscaisProdutos(){
      console.log('abrirClFiscaisProdutos')
      const routeData = this.$router.resolve(`/prodclfiscais/list`)
      window.open(routeData.href, '_blank')
    },


    regeraSaldosECustos(){
      console.log('regeraSaldosECustos')


      Swal.fire({
        position: "center",
        icon: "warning",
        title: "ATENÇÃO! Alguns registros podem ser excluídos",
        text: "Todo o histórico de saldo do produto será recalculado, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          this.updating = true
          api.get(`${getBaseUrl()}api/prgerasld`, {
            params: { idData: this.idData }
          }).then((res) => {
            console.log(res)

            if(res.data.success === false){
              console.log('contém success!')

              Swal.fire({
                position: "center",
                icon: "error",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.carregarDados()
              })
            }else{
              console.log('não contém success!')

              Swal.fire({
                position: "top-end",
                icon: "success",
                title: "Rotina executada com sucesso!",
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.carregarDados()
              })
            }
          })
        }
      })
    },

    reprocessaProdSaldoLoc() {
      console.log('reprocessaProdSaldoLoc')

      Swal.fire({
        position: "center",
        icon: "warning",
        title: "ATENÇÃO! Alguns registros podem ser excluídos",
        text: "Todo o histórico de saldo do produto será recalculado, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,
      }).then(result => {
        if (result.value) {

          api.get(`${getBaseUrl()}api/reprocessasaldoloc`, {
            params: {idData: this.idData}
          }).then((res) => {
            console.log(res)

            if(res.data.success === true){

              Swal.fire({
                position: "center",
                icon: "success",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              }).then(() => {
                this.carregarDados()
              })
            } else {
              Swal.fire({
                position: "center",
                icon: "error",
                title: res.data.message,
                showConfirmButton: false,
                timer: 1500
              })
            }
          })
        }
      })
    },


    confAtuImagem(){
      console.log('confAtuImagem')
      this.submittedImagem = true
      if (this.dropzoneFile.name){
        this.showModalAtuImg = false
        this.updating = true

        let arquivo = document.querySelector(".dropzoneFile").files[0]
        console.log(arquivo)
        let formData = new FormData()
        formData.append("iddata", this.idData)
        formData.append("tipo", this.tipoUpload)
        formData.append("filename", arquivo.name)
        formData.append("file", arquivo)

        api.post(`${getBaseUrl()}api/prodimg`,formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((res) => {
          console.log('then axios')
          console.log(res)

          this.updating = false
          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          }).then(() => {
            if (this.produtoData.imgs || this.produtoData.imgl){
              location.reload()
            }
          })

        }).catch((err) => {

          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          // let erros = err.response.data.errors
          // console.log(erros)
          // console.log(typeof  erros)
          // let listaErros = []
          // Object.keys(erros).forEach(key => {
          //   console.log(key, erros[key]);
          //   listaErros.push({
          //     'titulo': key,
          //     'mensagem': erros[key]
          //   })
          // });
          this.errosValid = err.response.data.errors
          this.updating = false
        })
      }
    },


    atualizarImagem(){
      console.log('atualizarImagemPeq')
      this.erroUpImagem = ''
      this.activeTab = 2
      this.showModalAtuImg = true
    },



    selectedFile(){
      console.log('selectedFile')
      this.dropzoneFile = document.querySelector(".dropzoneFile").files[0]
      // console.log(this.dropzoneFile.length)
      console.log(this.dropzoneFile)
      let fileName = this.dropzoneFile.name
      console.log(fileName)

      let ext = fileName.substr(fileName.lastIndexOf('.') + 1)

      console.log('ext')
      console.log(ext)

      if (ext !== 'png' && ext !== 'PNG' && ext !== 'jpg' && ext !== 'JPG'){
        this.erroUpImagem = 'Extensão do arquivo deve ser png ou jpg, favor corrigir.'
      } else {
        this.erroUpImagem = ''
      }


    },


    nomeStatusTab(strEntr){
      let result = 'Não Definido'
      switch (strEntr) {
        case 'A':
          result = 'Ativo'
          break
        default:
          result = 'Inativo'
          break
      }
      return result
    },


    selecionaProdPreco(dataID){
      console.log('selecionaProdPreco')
      console.log(dataID)
      this.showModalPreco = true

      // this.prodPrecoData.tabpreco = prodPreco.tabpreco
      // this.prodPrecoData.preco = prodPreco.preco
      // this.prodPrecoData.status = prodPreco.status
      // this.prodPrecoData.produto = prodPreco.produto
      // this.prodPrecoData = prodPreco

      this.prodPrecoData = this.prodPrecosData.find((reg) => reg.id === dataID)
      console.log('regSelecionado: ')
      console.log(this.prodPrecoData)

      this.dtListPesqTabPreco = [
        {
          'codigo': this.prodPrecoData.tabpreco,
          'descricao': this.prodPrecoData.descricao,
        }
      ]
    },

    confPreco(){
      console.log('confPreco')
      this.submittedPreco = true

      if (this.prodPrecoData.tabpreco && this.prodPrecoData.preco) {

        console.log('formSubmit_Preco_validado')
        this.showModalPreco = false

        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/prpreco`, {
          prodPrecoData: this.prodPrecoData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          // this.clienteData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.carregarDados()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false

        })
      }
    },


    pesqTabPreco(evt){
      console.log('pesqTabPreco')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.prodPrecoData.tabpreco = ''
        api.get(`${getBaseUrl()}api/tabprpesq`, {
          params: { q: query, t: 'S' }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqTabPreco = res.data
        })
      }
    },


    novoPreco(){
      console.log('novoPreco')
      this.prodPrecoData = {
        produto: this.produtoData.codigo,
        status: 'A'
      }
      this.activeTab = 4
      this.submittedPreco = false
      this.showModalPreco = true

    },

    onEnterCodFiscal(){
      console.log('onEnterCodFiscal')
      api.get(`${getBaseUrl()}api/prodclfiscod`, {
        params: { coddata: this.produtoData.codfis }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.codFiscData = res.data[0]
        this.dtListPesqCodFis = [
          {
            'codigo': this.codFiscData.codigo,
            'descricao': this.codFiscData.descricao,
          }
        ]
      })
    },

    integrCorpem(){
      console.log('integrCorpem')
      api.get(`${getBaseUrl()}api/spcadmerc`, {
        params: { idData: this.idData }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        const retCorpem = JSON.stringify(res.data);

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Integração Realizada com Sucesso",
          text: retCorpem,
          showConfirmButton: false,
          timer: 2500
        })
      })
    },


    estoqueCorpem(){
      console.log('estoqueCorpem')
      api.get(`${getBaseUrl()}api/spconsestq`, {
        params: { idData: this.idData }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        const retCorpem = JSON.stringify(res.data);

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Integração Realizada com Sucesso",
          text: retCorpem,
          showConfirmButton: false,
          timer: 2500
        })
      })
    },


    pesqGrupo(evt){
      console.log('pesqGrupo')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        console.log('vai pesquisar')


        // this.loadingCondPgto = true
        this.produtoData.grupo = ''
        api.get(`${getBaseUrl()}api/pgrpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios pesqGrupo')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqGrupo = res.data
        })
      }
    },


    pesqSubGrupo(evt){
      console.log('pesqSubGrupo')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        //this.loadingCondPgto = true
        this.produtoData.subgrupo = ''
        api.get(`${getBaseUrl()}api/psgrpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqSubGrupo = res.data
        })
      }
    },

    pesqClasse(evt){
      console.log('pesqClasse')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        //this.loadingCondPgto = true
        this.produtoData.classe = ''
        api.get(`${getBaseUrl()}api/pclapesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqClasse = res.data
        })
      }
    },

    pesqCodfis(evt){
      console.log('pesqCodfis')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.produtoData.codfis = ''
        api.get(`${getBaseUrl()}api/codfispesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqCodFis = res.data
        })
      }
    },

    pesqFabric(evt){
      console.log('pesqFabricante')
      console.log(evt)
      let query = evt
      console.log(query.length)
      if (query.length > 1){
        this.produtoData.fabric = ''
        api.get(`${getBaseUrl()}api/fabricpesq`, {
          params: { q: query }
        }).then((res) => {
          console.log('then axios')
          console.log(res.data)
          //console.log(res.data.length)
          this.dtListPesqFabric = res.data
        })
      }
    },

    testarUrl(){
      console.log('testarUrl: ' + this.grampoData.url)
      this.updatingAutomacoes = true

      api.get(`${getBaseUrl()}api/prgrampotst`, {
        params: { url: this.grampoData.url }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)
        this.cotacoesData = res.data[0]

        // this.title = `Editar Produto (${this.produtoData.id}) ${this.produtoData.descricao}`

        this.updatingAutomacoes = false
      });
    },

    editarGrampo(dataID){
      console.log('editarGrampo: ' + dataID)
      this.grampoData = this.gramposData.find((reg) => reg.id === dataID);
      this.showModalGrampo = true
      console.log('regSelecionado: ')
      console.log(this.regSelecionado)
    },

    deletarGrampo(dataID){
      console.log('deletarGrampo')

      Swal.fire({
        position: "center",
        icon: "question",
        title: "Exclusão de Registro",
        text: "Esta operação é irreversível, tem certeza que deseja continuar?",
        confirmButtonText: "Confirmar",
        cancelButtonText: "Cancelar",
        showCancelButton: true,
        showConfirmButton: true,

      }).then(result => {
        if (result.value) {
          this.updating = true
          api.delete(`${getBaseUrl()}api/prgrampo`, {
            params: {
              'iddata': dataID
            }
          }).then((res) => {
            console.log('then axios delete')
            console.log(res.data)
            this.carregarDados()
            Swal.fire({
              position: "top-end",
              icon: "success",
              title: "Informações excluídas com sucesso!",
              showConfirmButton: false,
              timer: 1500
            })
          })

        }
      })

    },

    calculaTotais(entradas, saidas) {
      //Calculando totais de entradas
      this.totalSaldoEntradas = entradas

      //Calculando totais de entradas
      this.totalSaldoSaidas = saidas

      this.totalSaldoLiquido = this.totalSaldoEntradas - this.totalSaldoSaidas
    },


    carregarDados(){
      this.updating = true

      if (this.dtIniFiltro === null) {
        let perIniPadrao = moment(new Date())
            .add(-15, 'days')
            .format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date())
            .format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
      }



      api.get(`${getBaseUrl()}api/produto`, {
        params: { iddata: this.idData, di: this.dtIniFiltro, df: this.dtFimFiltro }
      }).then((res) => {
        console.log('then axios')
        console.log(res.data)

        let prodData = res.data[0]





        if (prodData.tags){

          console.log('prodData.tags.lastIndexOf(",")')
          console.log(prodData.tags.lastIndexOf(","))

          const strToArrTags = prodData.tags.split(',').map(s => s.trim())
          prodData.tagsForm = strToArrTags
        }


        // console.log('strToArr')
        // console.log(strToArr)
        // console.log(this.naturegraData.destino)
        // cliData.classeForm = strToArr

        this.produtoData = prodData

        this.gramposData = res.data[1]
        this.cotacoesData = res.data[2]
        if (res.data[3]){
          this.grupoData = res.data[3]
          this.dtListPesqGrupo = [
            {
              'codigo': this.grupoData.codigo,
              'descricao': this.grupoData.descricao,
            }
          ]
        }
        if (res.data[4]){
          this.subGrupoData = res.data[4]
          this.dtListPesqSubGrupo = [
            {
              'codigo': this.subGrupoData.codigo,
              'descricao': this.subGrupoData.descricao,
            }
          ]
        }
        if (res.data[5]){
          this.classeData = res.data[5]
          this.dtListPesqClasse = [
            {
              'codigo': this.classeData.codigo,
              'descricao': this.classeData.descricao,
            }
          ]
        }
        if (res.data[6]){
          this.codFiscData = res.data[6]
          this.dtListPesqCodFis = [
            {
              'codigo': this.codFiscData.codigo,
              'descricao': this.codFiscData.descricao,
            }
          ]
        }
        if (res.data[7]){
          this.fabricData = res.data[7]
          this.dtListPesqFabric = [
            {
              'codigo': this.fabricData.codigo,
              'descricao': this.fabricData.descricao,
            }
          ]
        }
        if (res.data[8]){
          this.prodPrecosData = res.data[8]
        }

        if (res.data[9]){
          this.prodSaldoLocData = res.data[9]
          // console.log(`prodSaldoLocData: ${JSON.stringify(this.prodSaldoLocData)}`)
        }


        if (res.data[10].length > 0){
          this.prodSaldoData = res.data[10]
          this.prodSaldoData.forEach((value) => {
             value.dtmov_fmt = moment(value.dtmov).format('DD/MM/YYYY')
          })
        }



        if (res.data[11]){
          console.log('prodTrib')
          console.log(res.data[11])
          let prodTribs = res.data[11]
          prodTribs.forEach((prodTrib) => {
            console.log('prodTrib')
            console.log(prodTrib)
            if (prodTrib.tipo === 'PISCOFINS'){
              this.prodPisCofinsData = prodTrib
            } else if (prodTrib.tipo === 'ICMS'){
              this.prodIcmsData = prodTrib
            }
          })
        }

        if (res.data[19]) {
          const entradas = res.data[19]['entradas']
          const saidas = res.data[19]['saidas']
          this.calculaTotais(entradas, saidas)
        }

        if (this.produtoData.imgs){
          let imgTrat = this.produtoData.imgs.split(',')
          this.produtoData.imgSTrat = `${getBaseUrl()}/uploads/imgprods/peq/${imgTrat[0]}`
        }

        if (this.produtoData.imgl){
          let imgLTrat = this.produtoData.imgl.split(',')
          this.produtoData.imgLTrat = `${getBaseUrl()}/uploads/imgprods/grd/${imgLTrat[0]}`
        }

        let strToArr = null
        if (this.produtoData.tipo){
          strToArr = this.produtoData.tipo.split(',').map(s => s.trim())
        }
        // console.log('strToArr')
        // console.log(strToArr)
        this.produtoData.tipoForm = strToArr

        this.prodFornecsData = res.data[12]

        if (res.data[13]){
          this.prodAuxData = res.data[13]
        }

        if (res.data[14]){
          this.mediasData = res.data[14]
        }

        if (res.data[15]) {
          this.prodCategsData = res.data[15]
        }

        if (res.data[16]) {
          this.prodComposData = res.data[16]
        }

        if (res.data[17]) {
          this.prodVariacsData = res.data[17]
        }

        if (res.data[18]) {
          this.prodParam = res.data[18]
        }

        if (res.data[20]){
          this.empresa = res.data[20]
        }

        if (res.data[21]){
          this.flagDeleteProdutoSaldo = res.data[21]
        }



        this.idData = this.produtoData.id
        this.title = `Editar Produto (${this.produtoData.id}) ${this.produtoData.descricao}`

        const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')


        this.titleEstoque = `Estoque: ${dtIniFormated} - ${dtFimFormated}`

        this.updating = false
      });
    },


    confGrampo(){
      console.log('confGrampo')
      this.submittedRobo = true

      if (this.grampoData.url && this.grampoData.tipo) {

        console.log('formSubmit_validado')
        this.showModalGrampo = false

        this.updating = true
        this.errosValid = []
        api.post(`${getBaseUrl()}api/prgrampo`, {
          grampoData: this.grampoData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          // this.clienteData = res.data[0]
          this.updating = false

          Swal.fire({
            position: "top-end",
            icon: "success",
            title: "Informações salvas com sucesso!",
            showConfirmButton: false,
            timer: 1500
          })

          this.carregarDados()

        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.updating = false

        })
      }
    },

    novoRobo(){
      console.log('novoRobo')
      this.grampoData = {
        status: 'A',
        tipo: 'VE',
        recurs: 'DI',
      }
      this.showModalGrampo = true
    },

    avancarSeg(){
      console.log('avancarSeg')
      this.activeTab = 1
    },

    formSubmit(){
      console.log('formSubmit')
      this.submitted = true


      if (this.produtoData.tagsForm){
        this.produtoData.tags = this.produtoData.tagsForm.toString()
      }else{
        this.produtoData.tags = ''
      }


      if (this.produtoData.tipoForm){
        this.produtoData.tipo = this.produtoData.tipoForm.toString()
      }else{
        this.produtoData.tipo = ''
      }

      this.updating = true
      this.errosValid = []
      api.post(`${getBaseUrl()}api/produto`, {
        produtoData: this.produtoData,
        prodAuxData: this.prodAuxData
      }).then((res) => {
        console.log('then axios_post')
        console.log(res)

        this.updating = false

        Swal.fire({
          position: "top-end",
          icon: "success",
          title: "Informações salvas com sucesso!",
          showConfirmButton: false,
          timer: 1500
        }).then(() => {
          this.idData = res.data[0].id
          this.$router.push(`/produto/editar/${this.idData}`)
        })

        /* TROQUEI PELO MÉTODO atualizaPagina() -- Pablo Belmiro
        if (this.idData === 0){
          this.idData = res.data[0].id
          this.$router.replace('/produto/editar/' + this.idData)
        }*/

      }).catch((err) => {
        console.log('erro axios')
        // // console.log(err)
        // // console.log(err.response)
        console.log(err.response.data.errors)
        // let erros = err.response.data.errors
        // console.log(erros)
        // console.log(typeof  erros)
        // let listaErros = []
        // Object.keys(erros).forEach(key => {
        //   console.log(key, erros[key]);
        //   listaErros.push({
        //     'titulo': key,
        //     'mensagem': erros[key]
        //   })
        // });
        this.errosValid = err.response.data.errors
        this.updating = false
        this.activeTab = 0
      })
    },

    formatDate(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    formatInteger(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 0});
      }
      return 0.00;
    },

    formatDecimal(value) {
      // console.log('format_value')
      // console.log(value)
      // console.log(typeof value)
      if(value){
        let value_n = parseFloat(value)
        return value_n.toLocaleString('pt-BR', {style: 'decimal', minimumFractionDigits: 2});
      }
      return "0,00";
    },

  },


  mounted() {
    console.log('mounted_user_editar_0')
    let rota = this.$route.path
    // console.log(rota)
    let ultimaBarra = rota.lastIndexOf('/')
    if (ultimaBarra){
      this.idData = parseInt(rota.substring(ultimaBarra + 1))
    }
    console.log(`idData: ${this.idData}`)
    if (this.idData > 0){

      this.carregarDados()

    }else{

      this.title = `Criando Novo Produto`
      this.updating = false
    }

  }
};
</script>

<template>
  <Layout>
    <div class="mb-0" v-if="empresa !== null">
      <h6 class="text-muted">({{`${empresa.nome ?? ""}-${empresa.cnpj ?? ""} - Cód. ${empresa.codigo ?? ""}`}})</h6>
    </div>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>


    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>{{ erro }}
    </b-alert>

    <div class="checkout-tabs" v-if="!updating">

      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="d-flex align-items-start">

              <b-button variant="outline-primary" class="mx-2" @click="formSubmit"  >
                <i class="bx bx-save font-size-16 align-middle me-2"></i>
                Salvar Alterações
              </b-button>

              <b-button variant="outline-info"
                        class="mx-2"
                        @click="regeraSaldosECustos">
                <i class="bx bx-download font-size-16 align-middle me-2"></i>
                Regerar Saldos
              </b-button>

              <b-button variant="outline-warning"
                        class="mx-2"
                        @click="reprocessaProdSaldoLoc">
                <i class="bx bx-download font-size-16 align-middle me-2"></i>
                Reprocessamento de SaldoLoc
              </b-button>



              <!--              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="integrCorpem">-->
              <!--                <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>-->
              <!--                Integrar Cadastro Corpem-->
              <!--              </b-button>-->



              <b-button variant="outline-danger" class="mx-2" @click="novoPreco" :disabled="produtoData.id === 0" >
                <i class="bx bx-purchase-tag-alt font-size-16 align-middle me-2"></i>
                Novo Preço
              </b-button>

              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="atualizarImagem">
                <i class="bx bx-camera font-size-16 align-middle me-2"></i>
                Atualizar Imagem
              </b-button>


              <b-button variant="outline-info" class="mx-2" v-if="idData > 0" @click="criarCategoria">
                <i class="bx bx-area font-size-16 align-middle me-2"></i>
                Nova Categoria
              </b-button>


              <b-button variant="outline-warning" class="mx-2" v-if="idData > 0 && produtoData.formato === 'CO'"  @click="criarComposicao">
                <i class="bx bx-badge font-size-16 align-middle me-2"></i>
                Nova Composição
              </b-button>


              <b-button variant="outline-danger" class="mx-2" v-if="idData > 0 && produtoData.formato === 'VA'" @click="criarVariacao">
                <i class="bx bx-building font-size-16 align-middle me-2"></i>
                Nova Variação
              </b-button>

              <!--              <b-dropdown-->
              <!--                  ngbDropdown-->
              <!--                  menu-class="dropdown-menu-md dropdown-menu-end mx-2"-->
              <!--                  right-->
              <!--                  variant="light">-->
              <!--                <template v-slot:button-content>-->
              <!--                  <i class="mdi mdi-camera me-1"></i>-->
              <!--                  <span class="d-none d-sm-inline-block" ngbDropdownToggle>-->
              <!--                      Imagens-->
              <!--                      <i class="mdi mdi-chevron-down"></i>-->
              <!--                    </span>-->
              <!--                </template>-->


              <!--                <div v-if="!updating">-->

              <!--                  <b-dropdown-divider></b-dropdown-divider>-->
              <!--                  <a class="dropdown-item text-primary text-center"-->
              <!--                     @click="atualizarImagem"-->
              <!--                     href="javascript: void(0);">-->
              <!--                    Atualizar Imagem Pequena-->
              <!--                  </a>-->
              <!--                  <b-dropdown-divider></b-dropdown-divider>-->
              <!--                  <a class="dropdown-item text-primary text-center"-->
              <!--                     @click="atualizarImagem"-->
              <!--                     href="javascript: void(0);">-->
              <!--                    Atualizar Imagem Grande-->
              <!--                  </a>-->

              <!--                </div>-->

              <!--              </b-dropdown>-->


              <div class="col-sm-2" >

                <b-dropdown
                    ngbDropdown
                    menu-class="dropdown-menu-md dropdown-menu-end"
                    right
                    variant="light">
                  <template v-slot:button-content>
                    <i class="mdi mdi-help me-1"></i>
                    <span class="d-none d-sm-inline-block" ngbDropdownToggle>
                      Auxiliar
                      <i class="mdi mdi-chevron-down"></i>
                    </span>
                  </template>


                  <div v-if="!updating">
                    <!--                    <div class="dropdown-item-text">-->
                    <!--                      <div>-->
                    <!--                        <p class="text-muted mb-2">Total</p>-->
                    <!--                        <h5 class="mb-0">{{ formatInteger( clientesListPaged.data.length) }} (ativos) </h5>-->
                    <!--                      </div>-->
                    <!--                    </div>-->


                    <a class="dropdown-item text-primary text-center"
                       @click="abrirGruposProdutos"
                       href="javascript: void(0);">
                      Grupos de Produtos
                    </a>
                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="abrirSubGruposProdutos"
                       href="javascript: void(0);">
                      Sub-Grupos de Produtos
                    </a>
                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="abrirFabricantesProdutos"
                       href="javascript: void(0);">
                      Fabricantes de Produtos
                    </a>
                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="abrirClFiscaisProdutos"
                       href="javascript: void(0);">
                      Classificações Fiscais
                    </a>
                    <b-dropdown-divider></b-dropdown-divider>
                    <a class="dropdown-item text-primary text-center"
                       @click="exportarEstoque"
                       href="javascript: void(0);">
                      Exportar Estoque
                    </a>

                  </div>

                </b-dropdown>
              </div>



            </div>
          </div>
        </div>
      </div>


      <b-tabs
          v-model="activeTab"
          pills
          vertical
          nav-class="p-0"
          nav-wrapper-class="col-xl-2 col-sm-3"
          content-class="w-100">
        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-briefcase d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Principal</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">

                <div class="col-md-4 mb-2" v-if="idData === 0">
                  <span class="mb-2" for="empresaProd">Empresa</span>
                  <multiselect id="empresaProd"
                               @search-change="pesqEmpresa"
                               v-model="produtoData.empresa"
                               placeholder="Pesquisar Empresa"
                               :options="dtListPesqEmpresa"
                               :searchable="true"
                               track-by="codigo"
                               label="nome"
                               value-prop="codigo">
                    <template #option="slotProps">
                      <div class="row">
                        <div>
                            <span class="text-info">
                              {{ slotProps.option.cnpj }}
                            </span>
                          <span class="mx-4" >
                            </span>
                        </div>
                        <div class="mt-2 font-size-20">{{ slotProps.option.nome }}</div>
                        <span class="mx-4">
                          </span>
                        <span class="mx-4" >
                          </span>
                        <div class="align-items-end text-end align-content-end">Código: {{ slotProps.option.codigo }} </div>
                      </div>
                    </template>
                  </multiselect>
                </div>

                <h4 class="card-title">Informações Principais</h4>
                <!--                <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                <form class="needs-validation" @submit.prevent="formSubmit">


                  <div class=" row mb-3">
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label for="descricao">Descrição</label>
                        <input
                            id="descricao"
                            v-model="produtoData.descricao"
                            type="text"
                            class="form-control"
                            placeholder="Descrição"
                            :class="{'is-invalid': submitted && !produtoData.descricao}"/>
                        <div v-if="submitted && !produtoData.descricao"
                             class="invalid-feedback">
                          <span>Campo descrição obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-2">
                      <label for="unidade">Unidade</label>
                      <div class="position-relative">
                        <input
                            id="unidade"
                            type="text"
                            v-model="produtoData.unidade"
                            class="form-control"
                            placeholder="Unidade venda"
                            :class="{'is-invalid': submitted && !produtoData.unidade}"/>
                        <div v-if="submitted && !produtoData.unidade" class="invalid-feedback">
                          <span>Campo unidade obrigatório, favor preencher.</span>
                        </div>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label for="codigo">Código</label>
                      <div class="position-relative">
                        <input
                            id="codigo"
                            type="text"
                            v-model="produtoData.codigo"
                            class="form-control"
                            placeholder="codigo"
                            :class="{'is-invalid': submitted && !produtoData.codigo}"/>
                        <div v-if="submitted && !produtoData.codigo" class="invalid-feedback">
                          <span>Campo código obrigatório, favor preencher.</span>
                        </div>

                        <div class="chat-input-links" v-if="!produtoData.codigo">
                          <ul class="list-inline mb-0">
                            <li class="list-inline-item">
                              <a
                                  @click="gerarCodigo"
                                  href="javascript: void(0);"
                                  v-b-tooltip.hover
                                  placement="top"
                                  title="Gerar Código">
                                <i class="mdi mdi-refresh-circle"></i>
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>



                    <div class="col-md-4">
                      <label for="codfor">Código Fornecedor</label>
                      <div class="position-relative">
                        <input
                            id="codfor"
                            type="text"
                            v-model="produtoData.codfor"
                            class="form-control"
                            placeholder="Código Fornecedor"/>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label for="codbarra">Código de Barras</label>
                      <div class="position-relative">
                        <input
                            id="codbarra"
                            type="text"
                            v-model="produtoData.codbarra"
                            class="form-control"
                            placeholder="Código de Barras"/>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <label for="coddun14">Código DUN-14</label>
                      <div class="position-relative">
                        <input
                            id="coddun14"
                            type="text"
                            v-model="produtoData.coddun14"
                            class="form-control"
                            placeholder="Código DUN-14"/>
                      </div>
                    </div>
                  </div>




                  <div class=" row mb-3">

                    <div class="col-sm-4">
                      <label for="codred">Código Reduzido</label>
                      <div class="position-relative">
                        <input
                            id="codred"
                            type="text"
                            v-model="produtoData.codred"
                            class="form-control"
                            placeholder="Código Reduzido"/>
                      </div>
                    </div>

                    <div class="col-md-4">
                      <span class="mb-2">Grupo</span>
                      <multiselect id="grupo"
                                   @search-change="pesqGrupo"
                                   v-model="produtoData.grupo"
                                   placeholder="Pesquisar grupo"
                                   :options="dtListPesqGrupo"
                                   :searchable="true"
                                   track-by="textpesq"
                                   label="descricao"
                                   value-prop="codigo">
                        <template #option="slotProps">
                          <div class="row">
                            <div>
                            <span class="text-info">
                              {{ slotProps.option.codigo }}
                            </span>
                              <span class="mx-4" >
                            </span>
                            </div>
                            <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                            <span class="mx-4">
                          </span>
                            <span class="mx-4" >
                          </span>
                            <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                          </div>
                        </template>
                      </multiselect>
                    </div>

                    <div class="col-md-4">
                      <span class="mb-2">Sub Grupo</span>
                      <multiselect id="subgrupo"
                                   @search-change="pesqSubGrupo"
                                   v-model="produtoData.subgrupo"
                                   placeholder="Pesquisar sub grupo"
                                   :options="dtListPesqSubGrupo"
                                   :searchable="true"
                                   label="descricao"
                                   track-by="textpesq"
                                   value-prop="codigo">
                        <template #option="slotProps">
                          <div class="row">
                            <div>
                            <span class="text-info">
                              {{ slotProps.option.codigo }}
                            </span>
                              <span class="mx-4" >
                            </span>
                            </div>
                            <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                            <span class="mx-4">
                          </span>
                            <span class="mx-4" >
                          </span>
                            <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                          </div>
                        </template>
                      </multiselect>
                    </div>



                  </div>





                  <div class=" row mb-3">


                    <div class="col-sm-4">
                      <span class="mb-2">Tipo de Produto</span>
                      <multiselect v-model="produtoData.tipoForm"
                                   :mode="'tags'"
                                   :options="optionsTipo"
                                   placeholder="Selecionar tipo"
                                   label="cod"
                                   track-by="cod"
                                   value-prop="cod">
                        <template #option="slotProps">
                          <div style="width: 15%;">
                                <span class="text-info">
                                  {{ slotProps.option.cod }}
                                </span>
                          </div>
                          <div style="min-width: 85%;">
                                <span class="mx-4" >
                                  {{ slotProps.option.desc }}
                                </span>
                          </div>
                        </template>
                      </multiselect>
                    </div>


                    <div class="col-sm-4">
                      <span class="mb-2">Formato de Produto</span>
                      <multiselect v-model="produtoData.formato"
                                   :options="optionsFormato"
                                   placeholder="Selecionar formato"
                                   label="cod"
                                   track-by="cod"
                                   value-prop="cod">
                        <template #option="slotProps">
                          <div style="width: 15%;">
                                <span class="text-info">
                                  {{ slotProps.option.cod }}
                                </span>
                          </div>
                          <div style="min-width: 85%;">
                                <span class="mx-4" >
                                  {{ slotProps.option.desc }}
                                </span>
                          </div>
                        </template>
                      </multiselect>
                    </div>


                    <div class="col-sm-4">
                      <div class="mb-3 align-items-end align-content-end float-end">
                        <div class="d-flex">
                          <i class="bx bx-help-circle font-size-16 align-middle me-2" style="cursor:pointer" @click="showModalHelpLote = true"></i>
                          <span for="deflote">Utilizar lote</span>
                        </div>
                        <div class="position-relative">
                          <b-form-checkbox
                              switch size="lg"
                              v-model="produtoData.deflote">
                            {{ produtoData.deflote ? 'Ativo' : 'Inativo' }}
                          </b-form-checkbox>
                        </div>
                      </div>

                      <div class="mb-3 align-items-end align-content-end float-end">
                        <span for="tel1">Status</span>
                        <div class="position-relative">
                          <b-form-checkbox
                              switch size="lg"
                              value="A"
                              unchecked-value="I"
                              v-model="produtoData.status">
                            {{ produtoData.status === 'A' ? 'Ativo' : 'Inativo' }}
                          </b-form-checkbox>
                        </div>
                      </div>
                    </div>

                  </div>


<!--                  <hr />-->



                  <div class="col-lg-12">
                    <div class="card">
                      <div class="card-body">

                        <b-tabs v-model="activeTabPrinc"
                                pills justified
                                content-class="p-3 text-muted">

                          <b-tab active class="border-0">
                            <template v-slot:title>
                              <span class="d-inline-block d-sm-none">
                                <i class="fas fa-home"></i>
                              </span>
                              <span class="d-none d-sm-inline-block">Estrutura</span>
                            </template>

                            <div class=" row mb-3">

                              <div class="col-md-3">
                                <span class="mb-2">Classe</span>
                                <multiselect id="classe"
                                             @search-change="pesqClasse"
                                             v-model="produtoData.classe"
                                             placeholder="Pesquisar classe"
                                             :options="dtListPesqClasse"
                                             :searchable="true"
                                             label="descricao"
                                             track-by="textpesq"
                                             value-prop="codigo">
                                  <template #option="slotProps">
                                    <div class="row">
                                      <div>
                                        <span class="text-info">
                                          {{ slotProps.option.codigo }}
                                        </span>
                                        <span class="mx-4" >
                                        </span>
                                      </div>
                                      <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                                      <span class="mx-4">
                                      </span>
                                      <span class="mx-4">
                                      </span>
                                      <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                                    </div>
                                  </template>
                                </multiselect>
                              </div>

                              <div class="col-sm-3">
                                <label for="margem">Margem</label>
                                <div class="position-relative">
                                  <input
                                      id="margem"
                                      type="number"
                                      v-model="produtoData.margem"
                                      class="form-control text-end"
                                      placeholder="Margem"/>
                                </div>
                              </div>

                            </div>




                            <div class=" row mb-3">

                              <div class="col-sm-3">
                                <label for="garantia">Garantia</label>
                                <div class="position-relative">
                                  <input
                                      id="garantia"
                                      type="text"
                                      v-model="produtoData.garantia"
                                      class="form-control"/>
                                </div>
                              </div>

                              <div class="col-sm-3">
                                <label for="codfisv1">Código Classificação Fiscal</label>
                                <div class="position-relative">
                                  <input
                                      id="codfisv1"
                                      type="text"
                                      v-model="produtoData.codfis"
                                      class="form-control"
                                      v-on:keyup.enter="onEnterCodFiscal"
                                      v-maska="'####.##.##'"
                                      placeholder="Enter para pesquisar..."/>
                                </div>
                              </div>

                              <div class="col-sm-3">
                                <span class="mb-2">Classificação Fiscal</span>
                                <multiselect id="codfis"
                                             @search-change="pesqCodfis"
                                             v-model="produtoData.codfis"
                                             placeholder="Pesquisar classificação fiscal"
                                             :options="dtListPesqCodFis"
                                             :searchable="true"
                                             label="descricao"
                                             track-by="textpesq"
                                             value-prop="codigo">
                                  <template #option="slotProps">
                                    <div class="row">
                                      <div>
                                        <span class="text-info">
                                          {{ slotProps.option.codigo }}
                                        </span>
                                        <span class="mx-4" >

                                        </span>
                                      </div>
                                      <div class="mt-2 font-size-14">{{ slotProps.option.descricao }}</div>
                                      <span class="mx-4">

                                      </span>
                                      <span class="mx-4" >
                                      </span>
                                    </div>
                                  </template>
                                </multiselect>
                              </div>


                              <div class="col-sm-3">
                                <span class="mb-2">Fabricante</span>
                                <multiselect id="fabric"
                                             @search-change="pesqFabric"
                                             v-model="produtoData.fabric"
                                             placeholder="Pesquisar fabricante"
                                             :options="dtListPesqFabric"
                                             :searchable="true"
                                             label="descricao"
                                             track-by="textpesq"
                                             value-prop="codigo">
                                  <template #option="slotProps">
                                    <div class="row">
                                      <div>
                                        <span class="text-info">
                                          {{ slotProps.option.codigo }}
                                        </span>
                                        <span class="mx-4" >
                                        </span>
                                      </div>
                                      <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                                      <span class="mx-4"></span>
                                      <span class="mx-4" ></span>
                                      <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
                                    </div>
                                  </template>
                                </multiselect>
                              </div>



                            </div>



                            <div class="row mb-3">

                              <div class="col-sm-3">
                                <label for="pesobrt">Peso Bruto (kg)</label>
                                <div class="position-relative">
                                  <input
                                      id="pesobrt"
                                      type="number"
                                      v-model="produtoData.pesobrt"
                                      class="form-control text-end"
                                      placeholder="Peso bruto"/>
                                </div>
                              </div>


                              <div class="col-sm-3">
                                <label for="pesoliq">Peso Líquido (kg)</label>
                                <div class="position-relative">
                                  <input
                                      id="pesoliq"
                                      type="number"
                                      v-model="produtoData.pesoliq"
                                      class="form-control text-end"
                                      placeholder="Peso Líquido"/>
                                </div>
                              </div>




                            </div>

                            <div class="row mb-3">

                              <div class="col-sm-3">
                                <label for="compr">Comprimento (cm)</label>
                                <div class="position-relative">
                                  <input
                                      id="compr"
                                      type="number"
                                      v-model="produtoData.compr"
                                      class="form-control text-end"
                                      placeholder="Comprimento"/>
                                </div>
                              </div>

                              <div class="col-sm-3">
                                <label for="larg">Largura (cm)</label>
                                <div class="position-relative">
                                  <input
                                      id="larg"
                                      type="number"
                                      v-model="produtoData.larg"
                                      class="form-control text-end"
                                      placeholder="Largura"/>
                                </div>
                              </div>

                              <div class="col-sm-3">
                                <label for="altu">Altura (cm)</label>
                                <div class="position-relative">
                                  <input
                                      id="altu"
                                      type="number"
                                      v-model="produtoData.altu"
                                      class="form-control text-end"
                                      placeholder="Altura"/>
                                </div>
                              </div>

                              <div class="col-sm-3">
                                <label for="fatorcx">Fator Caixa</label>
                                <div class="position-relative">
                                  <input
                                      id="fatorcx"
                                      type="number"
                                      readonly
                                      v-model="produtoData.fatorcx"
                                      class="form-control text-end"
                                      placeholder="Fator Caixa"/>
                                </div>
                              </div>




                            </div>

                            <div class="row mb-3">


                              <div class="col-sm-12">
                                <div class="">

                                  <span class="text-black">Tag's </span>
                                  <multiselect v-model="produtoData.tagsForm"
                                               :mode="'tags'"
                                               class="mt-2"
                                               :options="optionsTags"
                                               placeholder="Selecionar tag para produto"
                                               label="cod"
                                               track-by="cod"
                                               value-prop="cod">
                                    <template #option="slotProps">
                                      <div style="min-width: 50px;">
                              <span class="text-info">
                                {{ slotProps.option.cod }}
                              </span>
                                      </div>
                                      <div style="min-width: 300px;">
                              <span class="mx-4" >
                                {{ slotProps.option.desc }}
                              </span>
                                      </div>
                                    </template>
                                  </multiselect>

                                </div>
                              </div>

                            </div>


                            <!--<hr class="mt-4" />

                            <div class="card-body">
                              <div class="card shadow-none border mb-0">
                                <div class="card-body">
                                  <h4 class="card-title mb-4">Regras de Tributação</h4>
                                  <div class="row" v-if="loadingRegras">
                                    <div class="col-12 text-center">
                                      <b-spinner type="grow"
                                                 class="m-6 mx-2"
                                                 variant="secondary"
                                                 role="status">
                                      </b-spinner>
                                      <b-spinner type="grow"
                                                 class="m-6 mx-2"
                                                 variant="secondary"
                                                 role="status">
                                      </b-spinner>
                                      <b-spinner type="grow"
                                                 class="m-6 mx-2"
                                                 variant="secondary"
                                                 role="status">
                                      </b-spinner>
                                    </div>
                                  </div>

                                  <b-tabs pills justified content-class="p-3 text-muted">
                                    <b-tab active class="border-0">
                                      <template v-slot:title>
                                            <span class="d-inline-block d-sm-none">
                                              <i class="fas fa-home"></i>
                                            </span>
                                        <span class="d-none d-sm-inline-block">Entrada</span>
                                      </template>

                                      <div class="row">
                                        <b-tabs pills justified content-class="p-3 text-muted">

                                          <b-tab active class="border-0">
                                            <template v-slot:title>
                                            <span class="d-inline-block d-sm-none">
                                              <i class="fas fa-home"></i>
                                            </span>
                                              <span class="d-none d-sm-inline-block">ICMS</span>
                                            </template>


                                            <div class="row">

                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="tributIcmsEntr">Grupo de Tributação</label>
                                                  <select
                                                      id="tributIcmsEntr"
                                                      v-model="prodTribsEntradaIcms.codtrib"
                                                      class="form-control">
                                                    <option value="A0">Alíquota Zero</option>
                                                    <option value="IS">Isento</option>
                                                    <option value="MN">Monofásico</option>
                                                    <option value="ST">Substituição Tributária</option>
                                                    <option value="TN">Tributação Normal</option>
                                                  </select>
                                                </div>
                                              </div>


                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="cfopIcmsEntr">CFOP</label>
                                                  <input
                                                      id="cfopIcmsEntr"
                                                      v-model="prodTribsEntradaIcms.cfop"
                                                      class="form-control text-end"
                                                      type="text"/>
                                                </div>
                                              </div>

                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="oriIcmsEntr">Origem(*)</label>
                                                  <select
                                                      id="oriIcmsEntr"
                                                      v-model="prodTribsEntradaIcms.ori"
                                                      required
                                                      class="form-control">
                                                    <option value="0">[0] nacional</option>
                                                    <option value="1">[1] estrangeira (importação direta)</option>
                                                    <option value="2">[2] estrangeira (adquirida no mercado interno)</option>
                                                    <option value="3">[3] nacional com mais de 40% de conteúdo estrangeiro</option>
                                                    <option value="4">[4] nacional produzida através de processos produtivos básicos</option>
                                                    <option value="5">[5] nacional com menos de 40% de conteúdo estrangeiro</option>
                                                    <option value="6">[6] estrangeira (importação direta) sem produto nacional similar</option>
                                                    <option value="7">[7] estrangeira (adquirida no mercado interno) sem produto nacional similar</option>
                                                    <option value="8">[8] nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%</option>
                                                  </select>
                                                </div>
                                              </div>

                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="icmsstEntr">Situação tributária(*)</label>
                                                  <select id="icmsstEntr" class="form-control" v-model="prodTribsEntradaIcms.entr">
                                                    <option value="00">[00] tributada integralmente</option>
                                                    <option value="02">[02] tributação monofásica própria sobre combustíveis</option>
                                                    <option value="10">[10] tributada e com cobrança do ICMS por substituição tributária</option>
                                                    <option value="10_partilha">[10_partilha] tributada e com cobrança do ICMS por substituição tributária. Operação interestadual para consumidor final com partilha do ICMS devido na operação entre a UF de origem e a do destinatário, ou a UF definida na legislação. (Ex. UF da concessionária de entrega do veículo)</option>
                                                    <option value="15">[15] tributação monofásica própria e com responsabilidade pela retenção sobre combustíveis</option>
                                                    <option value="20">[20] tributada com redução de base de cálculo</option>
                                                    <option value="30">[30] isenta ou não tributada e com cobrança do ICMS por substituição tributária</option>
                                                    <option value="40">[40] isenta</option>
                                                    <option value="41">[41] não tributada</option>
                                                    <option value="41_st">[41_st] não tributada com ICMS ST devido para a UF de destino, nas operações interestaduais de produtos que tiveram retenção antecipada de ICMS por ST na UF do remetente. Repasse via Substituto Tributário.</option>
                                                    <option value="50">[50] suspensão</option>
                                                    <option value="51">[51] diferimento (a exigência do preenchimento das informações do ICMS diferido fica a critério de cada UF)</option>
                                                    <option value="53">[53] tributação monofásica sobre combustíveis com recolhimento diferido</option>
                                                    <option value="60">[60] cobrado anteriormente por substituição tributária</option>
                                                    <option value="60_st">[60_st] cobrado anteriormente por substituição tributária com ICMS ST devido para a UF de destino, nas operações interestaduais de produtos que tiveram retenção antecipada de ICMS por ST na UF do remetente. Repasse via Substituto Tributário.</option>
                                                    <option value="61">[61] tributação monofásica sobre combustíveis cobrada anteriormente</option>
                                                    <option value="70">[70] tributada com redução de base de cálculo e com cobrança do ICMS por substituição tributária</option>
                                                    <option value="90">[90] outras (regime Normal)</option>
                                                    <option value="90_partilha">[90_partilha] outras (regime Normal). Operação interestadual para consumidor final com partilha do ICMS devido na operação entre a UF de origem e a do destinatário, ou a UF definida na legislação. (Ex. UF da concessionária de entrega do veículo)</option>
                                                    <option value="101">[101] tributada pelo Simples Nacional com permissão de crédito</option>
                                                    <option value="102">[102] tributada pelo Simples Nacional sem permissão de crédito</option>
                                                    <option value="103">[103] isenção do ICMS no Simples Nacional para faixa de receita bruta</option>
                                                    <option value="201">[201] tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária</option>
                                                    <option value="202">[202] tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária</option>
                                                    <option value="203">[203] isenção do ICMS nos Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária</option>
                                                    <option value="300">[300] imune</option>
                                                    <option value="400">[400] não tributada pelo Simples Nacional</option>
                                                    <option value="500">[500] ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação</option>
                                                    <option value="900">[900] outras (regime Simples Nacional)</option>
                                                  </select>
                                                </div>
                                              </div>


                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="aliq1IcmsEntr">Alíquota(%)</label>
                                                  <input
                                                      id="aliq1IcmsEntr"
                                                      v-model="prodTribsEntradaIcms.aliq1"
                                                      class="form-control text-end"
                                                      type="number"/>
                                                </div>
                                              </div>


                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="naturezaIcmsEntr">Natureza</label>
                                                  <input
                                                      id="naturezaIcmsEntr"
                                                      v-model="prodTribsEntradaIcms.natureza"
                                                      class="form-control text-end"
                                                      type="text"/>
                                                </div>
                                              </div>


                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="obsicmsEntr">Observações</label>
                                                  <textarea
                                                      id="obsicmsEntr"
                                                      v-model="prodTribsEntradaIcms.obs"
                                                      class="form-control"
                                                      rows="3"/>
                                                </div>
                                              </div>
                                            </div>
                                          </b-tab>


                                          <b-tab>
                                            <template v-slot:title>
                                            <span class="d-inline-block d-sm-none">
                                              <i class="far fa-envelope"></i>
                                            </span>
                                              <span class="d-none d-sm-inline-block">PIS / COFINS </span>
                                            </template>

                                            <div class="row">
                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="tributPisCofinsEntr">Grupo de Tributação</label>
                                                  <select
                                                      id="tributPisCofinsEntr"
                                                      v-model="prodTribsEntradaPisCofins.codtrib"
                                                      class="form-control">
                                                    <option value="A0">Alíquota Zero</option>
                                                    <option value="MN">Monofásico</option>
                                                    <option value="TN">Tributação Normal</option>
                                                    <option value="IS">Isento</option>
                                                    <option value="ST">Substituição Tributária</option>
                                                    <option value="TN">Tributação Normal</option>
                                                  </select>
                                                </div>
                                              </div>

                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="piscstEntr">Código Pis(*)</label>
                                                  <select id="piscstEntr" v-model="prodTribsEntradaPisCofins.entrPis" class="form-control" required>
                                                    <option value="01">[01] operação tributável: base de cálculo = valor da operação (alíquota normal - cumulativo/não cumulativo)</option>
                                                    <option value="02">[02] operação tributável: base de cálculo = valor da operação (alíquota diferenciada)</option>
                                                    <option value="03">[03] operação tributável: base de cálculo = quantidade vendida × alíquota por unidade de produto</option>
                                                    <option value="04">[04] operação tributável: tributação monofásica (alíquota zero)</option>
                                                    <option value="05">[05] operação tributável: substituição tributária</option>
                                                    <option value="06">[06] operação tributável: alíquota zero</option>
                                                    <option value="07">[07] operação isenta da contribuição</option>
                                                    <option value="08">[08] operação sem incidência da contribuição</option>
                                                    <option value="09">[09] operação com suspensão da contribuição</option>
                                                    <option value="49">[49] outras operações de saída</option>
                                                    <option value="50">[50] operação com direito a crédito: vinculada exclusivamente a receita tributada no mercado interno</option>
                                                    <option value="51">[51] operação com direito a crédito: vinculada exclusivamente a receita não tributada no mercado interno</option>
                                                    <option value="52">[52] operação com direito a crédito: vinculada exclusivamente a receita de exportação</option>
                                                    <option value="53">[53] operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno</option>
                                                    <option value="54">[54] operação com direito a crédito: vinculada a receitas tributadas no mercado interno e de exportação</option>
                                                    <option value="55">[55] operação com direito a crédito: vinculada a receitas não-tributadas no mercado interno e de exportação</option>
                                                    <option value="56">[56] operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação</option>
                                                    <option value="60">[60] crédito presumido: operação de aquisição vinculada exclusivamente a receita tributada no mercado interno</option>
                                                    <option value="61">[61] crédito presumido: operação de aquisição vinculada exclusivamente a receita não-tributada no mercado interno</option>
                                                    <option value="62">[62] crédito presumido: operação de aquisição vinculada exclusivamente a receita de exportação</option>
                                                    <option value="63">[63] crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno</option>
                                                    <option value="64">[64] crédito presumido: operação de aquisição vinculada a receitas tributadas no mercado interno e de exportação</option>
                                                    <option value="65">[65] crédito presumido: operação de aquisição vinculada a receitas não-tributadas no mercado interno e de exportação</option>
                                                    <option value="66">[66] crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação</option>
                                                    <option value="67">[67] crédito presumido: outras operações</option>
                                                    <option value="70">[70] operação de aquisição sem direito a crédito</option>
                                                    <option value="71">[71] operação de aquisição com isenção</option>
                                                    <option value="72">[72] operação de aquisição com suspensão</option>
                                                    <option value="73">[73] operação de aquisição a alíquota zero</option>
                                                    <option value="74">[74] operação de aquisição sem incidência da contribuição</option>
                                                    <option value="75">[75] operação de aquisição por substituição tributária</option>
                                                    <option value="98">[98] outras operações de entrada</option>
                                                    <option value="99">[99] outras operações</option>
                                                  </select>
                                                </div>
                                              </div>

                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="piscstEntr">Código Cofins(*)</label>
                                                  <select id="piscstEntr" v-model="prodTribsEntradaPisCofins.entrCofins" class="form-control" required>
                                                    <option value="01">[01] operação tributável: base de cálculo = valor da operação (alíquota normal - cumulativo/não cumulativo)</option>
                                                    <option value="02">[02] operação tributável: base de cálculo = valor da operação (alíquota diferenciada)</option>
                                                    <option value="03">[03] operação tributável: base de cálculo = quantidade vendida × alíquota por unidade de produto</option>
                                                    <option value="04">[04] operação tributável: tributação monofásica (alíquota zero)</option>
                                                    <option value="05">[05] operação tributável: substituição tributária</option>
                                                    <option value="06">[06] operação tributável: alíquota zero</option>
                                                    <option value="07">[07] operação isenta da contribuição</option>
                                                    <option value="08">[08] operação sem incidência da contribuição</option>
                                                    <option value="09">[09] operação com suspensão da contribuição</option>
                                                    <option value="49">[49] outras operações de saída</option>
                                                    <option value="50">[50] operação com direito a crédito: vinculada exclusivamente a receita tributada no mercado interno</option>
                                                    <option value="51">[51] operação com direito a crédito: vinculada exclusivamente a receita não tributada no mercado interno</option>
                                                    <option value="52">[52] operação com direito a crédito: vinculada exclusivamente a receita de exportação</option>
                                                    <option value="53">[53] operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno</option>
                                                    <option value="54">[54] operação com direito a crédito: vinculada a receitas tributadas no mercado interno e de exportação</option>
                                                    <option value="55">[55] operação com direito a crédito: vinculada a receitas não-tributadas no mercado interno e de exportação</option>
                                                    <option value="56">[56] operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação</option>
                                                    <option value="60">[60] crédito presumido: operação de aquisição vinculada exclusivamente a receita tributada no mercado interno</option>
                                                    <option value="61">[61] crédito presumido: operação de aquisição vinculada exclusivamente a receita não-tributada no mercado interno</option>
                                                    <option value="62">[62] crédito presumido: operação de aquisição vinculada exclusivamente a receita de exportação</option>
                                                    <option value="63">[63] crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno</option>
                                                    <option value="64">[64] crédito presumido: operação de aquisição vinculada a receitas tributadas no mercado interno e de exportação</option>
                                                    <option value="65">[65] crédito presumido: operação de aquisição vinculada a receitas não-tributadas no mercado interno e de exportação</option>
                                                    <option value="66">[66] crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação</option>
                                                    <option value="67">[67] crédito presumido: outras operações</option>
                                                    <option value="70">[70] operação de aquisição sem direito a crédito</option>
                                                    <option value="71">[71] operação de aquisição com isenção</option>
                                                    <option value="72">[72] operação de aquisição com suspensão</option>
                                                    <option value="73">[73] operação de aquisição a alíquota zero</option>
                                                    <option value="74">[74] operação de aquisição sem incidência da contribuição</option>
                                                    <option value="75">[75] operação de aquisição por substituição tributária</option>
                                                    <option value="98">[98] outras operações de entrada</option>
                                                    <option value="99">[99] outras operações</option>
                                                  </select>
                                                </div>
                                              </div>


                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="aliq1PisCofinsEntr">Alíquota Pis</label>
                                                  <input
                                                      id="aliq1PisCofinsEntr"
                                                      v-model="prodTribsEntradaPisCofins.aliq1"
                                                      class="form-control text-end"
                                                      type="number"/>
                                                </div>
                                              </div>

                                              <div class="col-md-3">
                                                <div class="mb-3">
                                                  <label for="aliq2PisCofinsEntr">Alíquota Cofins</label>
                                                  <input
                                                      id="aliq2PisCofinsEntr"
                                                      v-model="prodTribsEntradaPisCofins.aliq2"
                                                      class="form-control text-end"
                                                      type="number"/>
                                                </div>
                                              </div>

                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="naturezaPisCofinsEntr">Natureza</label>
                                                  <input
                                                      id="naturezaPisCofinsEntr"
                                                      v-model="prodTribsEntradaPisCofins.natureza"
                                                      class="form-control text-end"
                                                      type="text"/>
                                                </div>
                                              </div>

                                              <div class="col-md-12">
                                                <div class="mb-3">
                                                  <label for="obsicmsPisCofinsEntr">Observações</label>
                                                  <textarea
                                                      id="obsicmsPisCofinsEntr"
                                                      v-model="prodTribsEntradaPisCofins.obs"
                                                      class="form-control"
                                                      rows="3"/>
                                                </div>
                                              </div>
                                            </div>
                                          </b-tab>
                                        </b-tabs>
                                      </div>
                                    </b-tab>

                                    <b-tab class="border-0">
                                      <template v-slot:title>
                                            <span class="d-inline-block d-sm-none">
                                              <i class="fas fa-home"></i>
                                            </span>
                                        <span class="d-none d-sm-inline-block">Saída</span>
                                      </template>

                                      <div class="row">
                                        <b-tabs pills justified content-class="p-3 text-muted">

                                          <b-tab active class="border-0">
                                            <template v-slot:title>
                                            <span class="d-inline-block d-sm-none">
                                              <i class="fas fa-home"></i>
                                            </span>
                                              <span class="d-none d-sm-inline-block">ICMS</span>
                                            </template>


                                            <div class="row">

                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="tributIcmsSaida">Grupo de Tributação</label>
                                                  <select
                                                      id="tributIcmsSaida"
                                                      v-model="prodTribsSaidaIcms.codtrib"
                                                      class="form-control">
                                                    <option value="A0">Alíquota Zero</option>
                                                    <option value="IS">Isento</option>
                                                    <option value="MN">Monofásico</option>
                                                    <option value="ST">Substituição Tributária</option>
                                                    <option value="TN">Tributação Normal</option>
                                                  </select>
                                                </div>
                                              </div>


                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="cfopIcmsSaida">CFOP</label>
                                                  <input
                                                      id="cfopIcmsSaida"
                                                      v-model="prodTribsSaidaIcms.cfop"
                                                      class="form-control text-end"
                                                      type="text"/>
                                                </div>
                                              </div>


                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="oriIcmsSaida">Origem(*)</label>
                                                  <select
                                                      id="oriIcmsSaida"
                                                      v-model="prodTribsSaidaIcms.ori"
                                                      required
                                                      class="form-control">
                                                    <option value="0">[0] nacional</option>
                                                    <option value="1">[1] estrangeira (importação direta)</option>
                                                    <option value="2">[2] estrangeira (adquirida no mercado interno)</option>
                                                    <option value="3">[3] nacional com mais de 40% de conteúdo estrangeiro</option>
                                                    <option value="4">[4] nacional produzida através de processos produtivos básicos</option>
                                                    <option value="5">[5] nacional com menos de 40% de conteúdo estrangeiro</option>
                                                    <option value="6">[6] estrangeira (importação direta) sem produto nacional similar</option>
                                                    <option value="7">[7] estrangeira (adquirida no mercado interno) sem produto nacional similar</option>
                                                    <option value="8">[8] nacional, mercadoria ou bem com Conteúdo de Importação superior a 70%</option>
                                                  </select>
                                                </div>
                                              </div>

                                              <div class="col-sm-3">
                                                <div class="mb-3" disabled="true">
                                                  <label for="icmsstSaida">Situação tributária(*)</label>
                                                  <select id="icmsstSaida" class="form-control" v-model="prodTribsSaidaIcms.saida">
                                                    <option value="00">[00] tributada integralmente</option>
                                                    <option value="02">[02] tributação monofásica própria sobre combustíveis</option>
                                                    <option value="10">[10] tributada e com cobrança do ICMS por substituição tributária</option>
                                                    <option value="10_partilha">[10_partilha] tributada e com cobrança do ICMS por substituição tributária. Operação interestadual para consumidor final com partilha do ICMS devido na operação entre a UF de origem e a do destinatário, ou a UF definida na legislação. (Ex. UF da concessionária de entrega do veículo)</option>
                                                    <option value="15">[15] tributação monofásica própria e com responsabilidade pela retenção sobre combustíveis</option>
                                                    <option value="20">[20] tributada com redução de base de cálculo</option>
                                                    <option value="30">[30] isenta ou não tributada e com cobrança do ICMS por substituição tributária</option>
                                                    <option value="40">[40] isenta</option>
                                                    <option value="41">[41] não tributada</option>
                                                    <option value="41_st">[41_st] não tributada com ICMS ST devido para a UF de destino, nas operações interestaduais de produtos que tiveram retenção antecipada de ICMS por ST na UF do remetente. Repasse via Substituto Tributário.</option>
                                                    <option value="50">[50] suspensão</option>
                                                    <option value="51">[51] diferimento (a exigência do preenchimento das informações do ICMS diferido fica a critério de cada UF)</option>
                                                    <option value="53">[53] tributação monofásica sobre combustíveis com recolhimento diferido</option>
                                                    <option value="60">[60] cobrado anteriormente por substituição tributária</option>
                                                    <option value="60_st">[60_st] cobrado anteriormente por substituição tributária com ICMS ST devido para a UF de destino, nas operações interestaduais de produtos que tiveram retenção antecipada de ICMS por ST na UF do remetente. Repasse via Substituto Tributário.</option>
                                                    <option value="61">[61] tributação monofásica sobre combustíveis cobrada anteriormente</option>
                                                    <option value="70">[70] tributada com redução de base de cálculo e com cobrança do ICMS por substituição tributária</option>
                                                    <option value="90">[90] outras (regime Normal)</option>
                                                    <option value="90_partilha">[90_partilha] outras (regime Normal). Operação interestadual para consumidor final com partilha do ICMS devido na operação entre a UF de origem e a do destinatário, ou a UF definida na legislação. (Ex. UF da concessionária de entrega do veículo)</option>
                                                    <option value="101">[101] tributada pelo Simples Nacional com permissão de crédito</option>
                                                    <option value="102">[102] tributada pelo Simples Nacional sem permissão de crédito</option>
                                                    <option value="103">[103] isenção do ICMS no Simples Nacional para faixa de receita bruta</option>
                                                    <option value="201">[201] tributada pelo Simples Nacional com permissão de crédito e com cobrança do ICMS por substituição tributária</option>
                                                    <option value="202">[202] tributada pelo Simples Nacional sem permissão de crédito e com cobrança do ICMS por substituição tributária</option>
                                                    <option value="203">[203] isenção do ICMS nos Simples Nacional para faixa de receita bruta e com cobrança do ICMS por substituição tributária</option>
                                                    <option value="300">[300] imune</option>
                                                    <option value="400">[400] não tributada pelo Simples Nacional</option>
                                                    <option value="500">[500] ICMS cobrado anteriormente por substituição tributária (substituído) ou por antecipação</option>
                                                    <option value="900">[900] outras (regime Simples Nacional)</option>
                                                  </select>
                                                </div>
                                              </div>


                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="aliq1IcmsSaida">Alíquota(%)</label>
                                                  <input
                                                      id="aliq1IcmsSaida"
                                                      v-model="prodTribsSaidaIcms.aliq1"
                                                      class="form-control text-end"
                                                      type="number"/>
                                                </div>
                                              </div>


                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="naturezaIcmsSaida">Natureza</label>
                                                  <input
                                                      id="naturezaIcmsSaida"
                                                      v-model="prodTribsSaidaIcms.natureza"
                                                      class="form-control text-end"
                                                      type="text"/>
                                                </div>
                                              </div>


                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="obsIcmsSaida">Observações</label>
                                                  <textarea
                                                      id="obsIcmsSaida"
                                                      v-model="prodTribsSaidaIcms.obs"
                                                      class="form-control"
                                                      rows="3"/>
                                                </div>
                                              </div>
                                            </div>
                                          </b-tab>


                                          <b-tab>
                                            <template v-slot:title>
                                            <span class="d-inline-block d-sm-none">
                                              <i class="far fa-envelope"></i>
                                            </span>
                                              <span class="d-none d-sm-inline-block">PIS / COFINS </span>
                                            </template>

                                            <div class="row">
                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="tributPisCofinsSaida">Grupo de Tributação</label>
                                                  <select
                                                      id="tributPisCofinsSaida"
                                                      v-model="prodTribsSaidaPisCofins.codtrib"
                                                      class="form-control">
                                                    <option value="A0">Alíquota Zero</option>
                                                    <option value="MN">Monofásico</option>
                                                    <option value="TN">Tributação Normal</option>
                                                    <option value="IS">Isento</option>
                                                    <option value="ST">Substituição Tributária</option>
                                                    <option value="TN">Tributação Normal</option>
                                                  </select>
                                                </div>
                                              </div>


                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="piscstSaida">Código Pis(*)</label>
                                                  <select id="piscstSaida" v-model="prodTribsSaidaPisCofins.saidaPis" class="form-control" required>
                                                    <option value="01">[01] operação tributável: base de cálculo = valor da operação (alíquota normal - cumulativo/não cumulativo)</option>
                                                    <option value="02">[02] operação tributável: base de cálculo = valor da operação (alíquota diferenciada)</option>
                                                    <option value="03">[03] operação tributável: base de cálculo = quantidade vendida × alíquota por unidade de produto</option>
                                                    <option value="04">[04] operação tributável: tributação monofásica (alíquota zero)</option>
                                                    <option value="05">[05] operação tributável: substituição tributária</option>
                                                    <option value="06">[06] operação tributável: alíquota zero</option>
                                                    <option value="07">[07] operação isenta da contribuição</option>
                                                    <option value="08">[08] operação sem incidência da contribuição</option>
                                                    <option value="09">[09] operação com suspensão da contribuição</option>
                                                    <option value="49">[49] outras operações de saída</option>
                                                    <option value="50">[50] operação com direito a crédito: vinculada exclusivamente a receita tributada no mercado interno</option>
                                                    <option value="51">[51] operação com direito a crédito: vinculada exclusivamente a receita não tributada no mercado interno</option>
                                                    <option value="52">[52] operação com direito a crédito: vinculada exclusivamente a receita de exportação</option>
                                                    <option value="53">[53] operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno</option>
                                                    <option value="54">[54] operação com direito a crédito: vinculada a receitas tributadas no mercado interno e de exportação</option>
                                                    <option value="55">[55] operação com direito a crédito: vinculada a receitas não-tributadas no mercado interno e de exportação</option>
                                                    <option value="56">[56] operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação</option>
                                                    <option value="60">[60] crédito presumido: operação de aquisição vinculada exclusivamente a receita tributada no mercado interno</option>
                                                    <option value="61">[61] crédito presumido: operação de aquisição vinculada exclusivamente a receita não-tributada no mercado interno</option>
                                                    <option value="62">[62] crédito presumido: operação de aquisição vinculada exclusivamente a receita de exportação</option>
                                                    <option value="63">[63] crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno</option>
                                                    <option value="64">[64] crédito presumido: operação de aquisição vinculada a receitas tributadas no mercado interno e de exportação</option>
                                                    <option value="65">[65] crédito presumido: operação de aquisição vinculada a receitas não-tributadas no mercado interno e de exportação</option>
                                                    <option value="66">[66] crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação</option>
                                                    <option value="67">[67] crédito presumido: outras operações</option>
                                                    <option value="70">[70] operação de aquisição sem direito a crédito</option>
                                                    <option value="71">[71] operação de aquisição com isenção</option>
                                                    <option value="72">[72] operação de aquisição com suspensão</option>
                                                    <option value="73">[73] operação de aquisição a alíquota zero</option>
                                                    <option value="74">[74] operação de aquisição sem incidência da contribuição</option>
                                                    <option value="75">[75] operação de aquisição por substituição tributária</option>
                                                    <option value="98">[98] outras operações de entrada</option>
                                                    <option value="99">[99] outras operações</option>
                                                  </select>
                                                </div>
                                              </div>

                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="piscstSaida">Código Cofins(*)</label>
                                                  <select id="piscstSaida" v-model="prodTribsSaidaPisCofins.saidaCofins" class="form-control" required>
                                                    <option value="01">[01] operação tributável: base de cálculo = valor da operação (alíquota normal - cumulativo/não cumulativo)</option>
                                                    <option value="02">[02] operação tributável: base de cálculo = valor da operação (alíquota diferenciada)</option>
                                                    <option value="03">[03] operação tributável: base de cálculo = quantidade vendida × alíquota por unidade de produto</option>
                                                    <option value="04">[04] operação tributável: tributação monofásica (alíquota zero)</option>
                                                    <option value="05">[05] operação tributável: substituição tributária</option>
                                                    <option value="06">[06] operação tributável: alíquota zero</option>
                                                    <option value="07">[07] operação isenta da contribuição</option>
                                                    <option value="08">[08] operação sem incidência da contribuição</option>
                                                    <option value="09">[09] operação com suspensão da contribuição</option>
                                                    <option value="49">[49] outras operações de saída</option>
                                                    <option value="50">[50] operação com direito a crédito: vinculada exclusivamente a receita tributada no mercado interno</option>
                                                    <option value="51">[51] operação com direito a crédito: vinculada exclusivamente a receita não tributada no mercado interno</option>
                                                    <option value="52">[52] operação com direito a crédito: vinculada exclusivamente a receita de exportação</option>
                                                    <option value="53">[53] operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno</option>
                                                    <option value="54">[54] operação com direito a crédito: vinculada a receitas tributadas no mercado interno e de exportação</option>
                                                    <option value="55">[55] operação com direito a crédito: vinculada a receitas não-tributadas no mercado interno e de exportação</option>
                                                    <option value="56">[56] operação com direito a crédito: vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação</option>
                                                    <option value="60">[60] crédito presumido: operação de aquisição vinculada exclusivamente a receita tributada no mercado interno</option>
                                                    <option value="61">[61] crédito presumido: operação de aquisição vinculada exclusivamente a receita não-tributada no mercado interno</option>
                                                    <option value="62">[62] crédito presumido: operação de aquisição vinculada exclusivamente a receita de exportação</option>
                                                    <option value="63">[63] crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno</option>
                                                    <option value="64">[64] crédito presumido: operação de aquisição vinculada a receitas tributadas no mercado interno e de exportação</option>
                                                    <option value="65">[65] crédito presumido: operação de aquisição vinculada a receitas não-tributadas no mercado interno e de exportação</option>
                                                    <option value="66">[66] crédito presumido: operação de aquisição vinculada a receitas tributadas e não-tributadas no mercado interno e de exportação</option>
                                                    <option value="67">[67] crédito presumido: outras operações</option>
                                                    <option value="70">[70] operação de aquisição sem direito a crédito</option>
                                                    <option value="71">[71] operação de aquisição com isenção</option>
                                                    <option value="72">[72] operação de aquisição com suspensão</option>
                                                    <option value="73">[73] operação de aquisição a alíquota zero</option>
                                                    <option value="74">[74] operação de aquisição sem incidência da contribuição</option>
                                                    <option value="75">[75] operação de aquisição por substituição tributária</option>
                                                    <option value="98">[98] outras operações de entrada</option>
                                                    <option value="99">[99] outras operações</option>
                                                  </select>
                                                </div>
                                              </div>

                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="aliq1PisCofinsSaida">Alíquota Pis</label>
                                                  <input
                                                      id="aliq1PisCofinsSaida"
                                                      v-model="prodTribsSaidaPisCofins.aliq1"
                                                      class="form-control text-end"
                                                      type="number"/>
                                                </div>
                                              </div>

                                              <div class="col-md-3">
                                                <div class="mb-3">
                                                  <label for="aliq2PisCofinsSaida">Alíquota Cofins</label>
                                                  <input
                                                      id="aliq2PisCofinsSaida"
                                                      v-model="prodTribsSaidaPisCofins.aliq2"
                                                      class="form-control text-end"
                                                      type="number"/>
                                                </div>
                                              </div>

                                              <div class="col-sm-3">
                                                <div class="mb-3">
                                                  <label for="naturezaPisCofinsSaida">Natureza</label>
                                                  <input
                                                      id="naturezaPisCofinsSaida"
                                                      v-model="prodTribsSaidaPisCofins.natureza"
                                                      class="form-control text-end"
                                                      type="text"/>
                                                </div>
                                              </div>

                                              <div class="col-md-12">
                                                <div class="mb-3">
                                                  <label for="obsPisCofinsSaida">Observações</label>
                                                  <textarea
                                                      id="obsPisCofinsSaida"
                                                      v-model="prodTribsSaidaPisCofins.obs"
                                                      class="form-control"
                                                      rows="3"/>
                                                </div>
                                              </div>
                                            </div>
                                          </b-tab>
                                        </b-tabs>
                                      </div>
                                    </b-tab>
                                  </b-tabs>
                                </div>
                              </div>
                            </div>-->

                            <hr class="mt-4" />

                            <div class="row mb-3">
                              <div class="col-sm-12">
                                <div class="">
                                  <div class="card">
                                    <div class="card-body">
                                      <h4 class="card-title">Descrição Complementar</h4>

                                      <textarea
                                          id="obsitem"
                                          v-model="prodAuxData.descaux"
                                          type="text"
                                          rows="10"
                                          class="form-control"
                                          placeholder="Descrição Complementar"/>


                                      <div class="col-lg-12">
                                        <div class="card">
                                          <div class="card-body">

                                            <b-card no-body class="mb-1 shadow-none">
                                              <b-card-header header-tag="header" role="tab">
                                                <h6 class="m-0">
                                                  <a
                                                      v-b-toggle.accordion-1
                                                      class="text-dark"
                                                      href="javascript: void(0);"
                                                  >Renderização Descrição Complementar</a>
                                                </h6>
                                              </b-card-header>
                                              <b-collapse id="accordion-1" visible accordion="my-accordion-1" role="tabpanel">
                                                <b-card-body>
                                                  <div class="row mb-2">
                                                    <span v-html="prodAuxData.descaux"></span>
                                                  </div>
                                                </b-card-body>
                                              </b-collapse>
                                            </b-card>
                                          </div>
                                        </div>
                                      </div>


                                    </div>
                                  </div>
                                </div>
                              </div>

                            </div>

                          </b-tab>



                          <b-tab v-if="produtoData && produtoData.formato === 'VA'">
                            <template v-slot:title>
                              <span class="d-inline-block d-sm-none">
                                <i class="far fa-user"></i>
                              </span>
                              <span class="d-none d-sm-inline-block">Variação</span>
                            </template>

                            <div class="row">
                              <div class="table-responsive">
                                <table class="table align-middle mb-0 table-nowrap">
                                  <thead class="table-light">
                                  <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Atributo</th>
                                    <th scope="col">Opção</th>
                                    <th scope="col">Data</th>
                                    <th scope="col" class="text-end">Ações</th>
                                  </tr>
                                  </thead>
                                  <tbody>
                                  <tr v-for="data in prodVariacsData" :key="data.id">
                                    <td>
                                      <a href="javascript: void(0);"
                                         class="text-body fw-bold">
                                        {{ data.id }}
                                      </a>
                                    </td>
                                    <td>
                                      <a href="javascript: void(0);"
                                         class="text-body fw-bold">
                                        {{ data.atributo }}
                                      </a>
                                    </td>
                                    <td>{{ data.opcao }}</td>
                                    <td>{{ formatDateTime(data.created_at) }}</td>
                                    <td class="text-end">
                                      <b-button variant="outline-danger" @click="delVariac(data.id)">
                                        <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                      </b-button>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </b-tab>





                          <b-tab v-if="produtoData.formato === 'CO'">
                            <template v-slot:title>
                              <span class="d-inline-block d-sm-none">
                                <i class="far fa-envelope"></i>
                              </span>
                              <span class="d-none d-sm-inline-block">Composição</span>
                            </template>

                              <div class="row">
                                <div class="table-responsive">
                                  <table class="table align-middle mb-0 table-nowrap">
                                    <thead class="table-light">
                                    <tr>
                                      <th scope="col">ID</th>
                                      <th scope="col">Produto</th>
                                      <th scope="col">Código</th>
                                      <th scope="col" class="text-end">Quantidade</th>
                                      <th scope="col">Fator</th>
                                      <th scope="col">Data</th>
                                      <th scope="col" class="text-end">Ações</th>
                                    </tr>
                                    </thead>
                                    <tbody>

                                    <tr v-for="data in prodComposData" :key="data.id">
                                      <td>
                                        <a href="javascript: void(0);"
                                           class="text-body fw-bold">
                                          {{ data.id }}
                                        </a>
                                      </td>
                                      <td>
                                        <a href="javascript: void(0);"
                                           class="text-body fw-bold">
                                          {{ data.descricao }}
                                        </a>
                                      </td>
                                      <td>{{ data.codigo }}</td>
                                      <td class="text-end">{{ formatDecimal(data.qtd) }}</td>
                                      <td>{{ data.fator }}</td>
                                      <td>{{ formatDateTime(data.created_at) }}</td>
                                      <td class="text-end">
<!--                                        <b-button variant="outline-warning" @click="editCompos(data)">-->
<!--                                          <i class="mdi mdi-pen d-block font-size-16"></i>-->
<!--                                        </b-button>-->
                                        <b-button variant="outline-danger" @click="delCompos(data.id)">
                                          <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                        </b-button>
                                      </td>
                                    </tr>

                                    </tbody>
                                  </table>
                                </div>
                              </div>

                          </b-tab>

                          <!-- PABLO - DESABILITEI A ABA DE PARÂMETROS DE PRODUTOS POR ENQUANTO - APENAS REGRA DE LOTE UTILIZADA-->
                          <!--<b-tab active class="border-0">
                            <template v-slot:title>
                              <span class="d-inline-block d-sm-none">
                                <i class="fas fa-home"></i>
                              </span>
                              <span class="d-none d-sm-inline-block">Parâmetros</span>
                            </template>

                            <div class="col-lg-12">
                              <div class="card">
                                <div class="card-body">
                                  <div class="d-flex align-items-start">

                                    <b-button variant="outline-primary" class="mx-2" @click="novoProdParam">
                                      <i class="bx bx-plus font-size-16 align-middle me-2"></i>
                                      Novo Parâmetro
                                    </b-button>

                                  </div>
                                </div>
                              </div>
                            </div>

                            <div class=" row mb-3">
                              <div class="table-responsive">
                                <table class="table align-middle mb-0 table-nowrap">
                                  <thead class="table-light">
                                  <tr>
                                    <th scope="col">ID</th>
                                    <th scope="col">Descrição</th>
                                    <th scope="col">Valor</th>
                                    <th scope="col">Código</th>
                                    <th scope="col">Criado em</th>
                                    <th scope="col">Usuário</th>
                                    <th scope="col">Ações</th>
                                  </tr>
                                  </thead>
                                  <tbody>


                                  <tr v-for="data in prodParam" :key="data.id">

                                    <td>
                                      <h5 class="font-size-14 text-truncate">
                                        <span class="text-dark">
                                          {{ data.id }}
                                        </span>
                                      </h5>
                                    </td>

                                    <td>
                                      <h5 class="font-size-14 text-truncate">
                                        <span class="text-dark">
                                          {{ formataDescProdParam(data) }}
                                        </span>
                                      </h5>
                                    </td>

                                    <td>
                                      <h5 class="font-size-14 text-truncate">
                                        <span class="text-dark">
                                          {{ data.valor }}
                                        </span>
                                      </h5>
                                    </td>

                                    <td>
                                      <h5 class="font-size-14 text-truncate">
                                        <span class="text-dark">
                                          {{ data.codigo }}
                                        </span>
                                      </h5>
                                    </td>

                                    <td>
                                      <h5 class="font-size-14 text-truncate">
                                        <span class="text-dark">
                                          {{ formatDate(data.created_at) }}
                                        </span>
                                      </h5>
                                    </td>

                                    <td>
                                      <h5 class="font-size-14 text-truncate">
                                        <span class="text-dark">
                                          {{ data.created_by }}
                                        </span>
                                      </h5>
                                    </td>


                                    <td>
                                      <div class="button-items">
                                        <b-button variant="outline-danger" @click="deletarProdParam(data.id)">
                                          <i class="mdi mdi-trash-can d-block font-size-16"></i>
                                        </b-button>
                                      </div>
                                    </td>
                                  </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </b-tab>-->
                        </b-tabs>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </b-card-text>
        </b-tab>


        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-layer d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Estoque</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div>
                  <h4 class="card-title" @click="showModalPeriodo = true">{{ titleEstoque }}</h4>

                  <div class="mt-4 mb-4">

                    <div class="row">
                      <!--<div class="col-xl-2 col-sm-2">
                        <div class="mb-3">
                          <label class="card-radio-label mb-2">
                            <input
                                type="radio"
                                name="currency"
                                id="buycurrencyoption1"
                                class="card-radio-input"
                                checked/>
                            <div class="card-radio">
                              <div>
                                <i class="mdi mdi-sign-real-estate font-size-24 text-warning align-middle me-2">
                                </i>
                                <span>Real</span>
                                <p class="text-muted mb-1">Saldo: {{ formatInteger(this.produtoData.saldo) }} UND</p>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>-->

                      <!--<div class="col-xl-2 col-sm-2">
                        <div class="mb-3">
                          <label class="card-radio-label mb-2">
                            <input
                                type="radio"
                                name="currency"
                                id="buycurrencyoption2"
                                class="card-radio-input"/>
                            <div class="card-radio">
                              <div>
                                <i class="mdi mdi-bell font-size-24 text-danger align-middle me-2">
                                </i>
                                <span>Falta</span>
                                <p class="text-muted mb-1">Saldo: {{ formatInteger(produtoData.saldofalta) }} UND</p>
                              </div>
                            </div>
                          </label>-->
                          <!-- POSTERIORMENTE IMPLEMENTAR OS VALORES TOTAIS -->
                          <!-- <div>-->
                          <!-- <p class="text-muted mb-1">Unitário: R$ {{ formatDecimal(prodSaldoFalta.custo) }}</p>-->
                          <!-- <h5 class="font-size-16">Total: R$ {{ formatDecimal(prodSaldoFalta.total) }} </h5>-->
                          <!--</div>-->
                        <!--</div>
                      </div>-->


                      <div class="col-xl-2 col-sm-2">
                        <div class="mb-3">
                          <label class="card-radio-label mb-2">
                            <input
                                type="radio"
                                name="currency"
                                id="buycurrencyoption1"
                                class="card-radio-input"
                                checked/>
                            <div class="card-radio">
                              <div>
                                <i class="mdi mdi-binoculars font-size-24 text-success align-middle me-2">
                                </i>
                                <span>Prevista</span>
                                <p class="text-muted mb-1">Saldo: {{ formatInteger(produtoData.saldoprev) }} UND</p>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>


                      <div class="col-xl-2 col-sm-2">
                        <div class="mb-3">
                          <label class="card-radio-label mb-2">
                            <input
                                type="radio"
                                class="card-radio-input"/>
                            <div class="card-radio">
                              <div>
                                <i class="mdi mdi-check-box-multiple-outline font-size-24 text-success align-middle me-2">
                                </i>
                                <span>Disponível</span>
                                <p class="text-muted mb-1">Saldo: {{ formatInteger(produtoData.saldodisp) }} UND</p>
                              </div>
                            </div>
                          </label>
                          <!--                          POSTERIORMENTE IMPLEMENTAR OS VALORES TOTAIS -->
                          <!--<div>-->
                          <!--<p class="text-muted mb-1">Unitário: R$ {{ formatDecimal(prodSaldoDisponivel.custo) }}</p>-->
                          <!--<h5 class="font-size-16">Total: R$ {{ formatDecimal(prodSaldoDisponivel.total) }} </h5>-->
                          <!--</div>-->
                        </div>
                      </div>


                      <div class="col-xl-2 col-sm-2">
                        <div class="mb-3">
                          <label class="card-radio-label mb-2">
                            <input
                                type="radio"
                                name="currency"
                                id="buycurrencyoption3"
                                class="card-radio-input"/>
                            <div class="card-radio">
                              <div>
                                <i class="mdi mdi-shield-check-outline font-size-24 text-warning align-middle me-2"></i>
                                <span>Em separação</span>
                                <p class="text-muted mb-1">Saldo: {{ formatInteger(produtoData.saldoreser) }} UND</p>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>

                      <!--<div class="col-xl-2 col-sm-2">
                        <div class="mb-3">
                          <label class="card-radio-label mb-2">
                            <input
                                type="radio"
                                name="currency"
                                id="buycurrencyoption3"
                                class="card-radio-input"/>
                            <div class="card-radio">
                              <div>
                                <i class="mdi mdi-wall font-size-24 text-danger align-middle me-2"></i>
                                <span>Bloqueada</span>
                                <p class="text-muted mb-1">Saldo: {{ formatInteger(produtoData.saldobloq) }} UND</p>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>-->

                      <!--<div class="col-xl-2 col-sm-2">
                        <div class="mb-3">
                          <label class="card-radio-label mb-2">
                            <input
                                type="radio"
                                name="currency"
                                class="card-radio-input"/>
                            <div class="card-radio">
                              <div>
                                <i class="mdi mdi-bell font-size-24 text-danger align-middle me-2"></i>
                                <span>Negativo</span>
                                <p class="text-muted mb-1">
                                  Saldo: {{ formatInteger(produtoData.saldonegat) }} UND
                                </p>
                              </div>
                            </div>
                          </label>-->
                          <!--POSTERIORMENTE IMPLEMENTAR OS VALORES TOTAIS -->
                          <!--<div>-->
                          <!--<p class="text-muted mb-1">Unitário: R$ {{ formatDecimal(prodSaldoBloqueada.custo) }}</p>-->
                          <!--<h5 class="font-size-16">Total: R$ {{ formatDecimal(prodSaldoBloqueada.total) }} </h5>-->
                          <!--</div>-->
                        <!--</div>
                      </div>-->

                      <div class="col-xl-2 col-sm-2">
                        <div class="mb-3">
                          <label class="card-radio-label mb-2">
                            <input
                                type="radio"
                                class="card-radio-input"/>
                            <div class="card-radio">
                              <div>
                                <i class="bx bx-exit font-size-24 text-danger align-middle me-2">
                                </i>
                                <span>Saidas</span>
                                <p class="text-muted mb-1">Saldo: {{ formatInteger(produtoData.saldosaida) }} UND</p>
                              </div>
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>

                    <div class="row">

                    </div>

                  </div>

                  <h5 class="mt-5 mb-3 font-size-15">Detalhes locais de estoque</h5>
                  <div class="col-md-11">
                    <div class="p-4 border">
                      <div class="table-responsive">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>
                            <th scope="col">Ação</th>
                            <th scope="col">ID OS</th>
                            <!--<th scope="col">Local</th>-->
                            <th scope="col">Lote</th>
                            <th scope="col">Endereço</th>
                            <th scope="col">Validade</th>
                            <th scope="col">Palete</th>
                            <th class="text-end" scope="col">Saldo</th>
                            <th class="text-end" scope="col">Custo</th>
                            <th class="text-end" scope="col">Total</th>
                          </tr>
                          </thead>
                          <tbody>
                          <tr v-for="data in prodSaldoLocData"
                              :key="data.id"
                              :class="{
                                'table-danger': data.endwms === 'NEGATIVO' || (!data.saldo || data.saldo <= 0) || data.endwms === 'AVARIA' || data.endwms === 'FALTA',
                                'table-warning': data.endwms === 'BLOQUEADO' || data.endwms === 'EM SEPARAÇÃO' || data.endwms === 'EM RECEBIMENTO',
                                'table-success': data.saldo > 0
                              }">
                            <td>
                              <div class="button-items" v-if="!['NEGATIVO', 'FALTA', 'EM SEPARAÇÃO', 'EM RECEBIMENTO'].includes(data.endwms)">
                                <b-button variant="outline-primary" @click="remanejarSaldo(data)" title="Remanejar localização do estoque">
                                  <i class="bx bx-package d-block font-size-16"></i>
                                </b-button>
                              </div>
                            </td>
                            <td style="cursor: pointer" @click="abreOsSeparacao(data.wmsos_id)" title="Abrir OS associada">{{ data.wmsos_id ?? '-' }}</td>
                            <!--<td>{{ data.local }}</td>-->
                            <td>{{ data.lote ?? '-' }}</td>
                            <td>{{ data.endwms }}</td>
                            <td>{{ data.dtvalid ?? '-' }}</td>
                            <td>{{ data.palete ?? '-' }}</td>
                            <td class="text-end">{{ formatDecimal(data.saldo) }}</td>
                            <td class="text-end">{{ formatDecimal(data.custo) }}</td>
                            <td class="text-end">{{ formatDecimal(data.total) }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>


                  <hr>

                  <div class="row">
                    <div class="d-flex">
                      <h5 class="font-size-16 mx-2 mb-2">
                        Histórico
                      </h5>
                    </div>

                    <!--<div class="d-flex">
                      <h5 class="font-size-14 mx-2">Inclui virtuais?</h5>
                      <b-form-checkbox switch size="md" v-model="incluiHistSaldoVirtual" @click="recontarSaldos">
                        {{ incluiHistSaldoVirtual === true ? 'On' : 'Off' }}
                      </b-form-checkbox>
                    </div>-->
                  </div>

                  <div class="col-md-11">

                    <div class="p-4 border">

                      <div class="row mb-2">
                        <div class="col-md-3 d-flex">
                          <i class="bx bx-exit font-size-24 text-success align-middle me-2">
                          </i>
                          <span class="me-2">Entradas: </span>
                          <p class="text-success mb-1">{{formatDecimal(totalSaldoEntradas)}}</p>
                        </div>

                        <div class="col-md-3 d-flex">
                          <i class="bx bx-exit font-size-24 text-danger align-middle me-2">
                          </i>
                          <span class="me-2">Saídas: </span>
                          <p class="text-danger mb-1">{{(formatDecimal(totalSaldoSaidas))}}</p>
                        </div>

                        <div class="col-md-3 d-flex ">
                          <i class="mdi mdi-sign-real-estate font-size-24 text-warning align-middle me-2" style="margin-top: -5px"></i>
                          <span class="me-2">Saldo: </span>
                          <p class="text-warning mb-1">{{formatDecimal(totalSaldoLiquido)}}</p>
                        </div>
                        <div class="col-md-3"></div>
                      </div>

                      <div class="table-responsive">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>
                            <th scope="col">Mov.</th>
                            <th scope="col">Seq.</th>
                            <th scope="col">Código</th>
                            <th scope="col" class="text-center">Data</th>
                            <th scope="col" class="text-end" title="Saldo Anterior">Sld.Ant.</th>
                            <th scope="col" class="text-end">Qtd.Ent.</th>
                            <th scope="col" class="text-end">Qtd.Saida</th>
                            <th scope="col" class="text-end">Saldo</th>
                            <th scope="col">Id OS</th>
                            <th scope="col">Lote</th>
                            <th scope="col">Validade</th>
                            <th scope="col">Palete</th>
                            <th scope="col">Endereço</th>
                            <th scope="col" class="text-end">Cst.Ant.</th>
                            <th scope="col" class="text-end">Tot.Ant.</th>
                            <th scope="col" class="text-end">Custo</th>
                            <th scope="col" class="text-end">Tot.Ent.</th>
                            <th scope="col" class="text-end">Tot.Saida</th>
                            <th scope="col" class="text-end">Custo</th>
                            <th scope="col" class="text-end" v-if="flagDeleteProdutoSaldo !== null">Ação</th>
                          </tr>
                          </thead>
                          <tbody>
                          <!-- .filter(d => d.endwms !== 'SAIDA' && d.endwms !== 'EM SEPARAÇÃO' && d.endwms !== 'BLOQUEADO')" -->
                            <template v-if="prodSaldoData">
                              <tr v-for="data in prodSaldoData"
                                  :key="data.id"
                                  :class="{
                                  'table-light': data.endwms === 'SAIDA',
                                  'table-info': data.endwms === 'ENTRADA',
                                  'table-warning': data.endwms === 'EM SEPARAÇÃO' || data.endwms === 'BLOQUEADO' || data.endwms === 'RESERVADO',
                                  'table-success': data.qtdentr > 0,
                                  'table-danger': data.qtdsaida > 0 || data.endwms === 'NEGATIVO' || data.endwms === 'AVARIA',
                                }"
                              >

                                <td>
                                  <h5 class="font-size-14 text-truncate">
                                    <a href="javascript:void(0);" class="text-dark" @click="abrirMov(data)" >
                                      {{ data.movid }}
                                    </a>
                                  </h5>
                                  <p class="text-muted mb-0">{{ data.movori }}</p>
                                </td>
                                <td>{{ data.seq }}</td>
                                <td>{{ data.numnota ?? '-' }}</td>
                                <td>{{ formatDate(data.dtmov) }}</td>
                                <td class="text-end">{{ formatDecimal(data.saldoant) }}</td>
                                <td class="text-end">{{ formatDecimal(data.qtdentr) }}</td>
                                <td class="text-end">{{ formatDecimal(data.qtdsaida) }}</td>
                                <td class="text-end">{{ formatDecimal(data.saldoatu) }}</td>
                                <td>{{ data.wmsos_id ?? '-' }}</td>
                                <td>{{ data.lote ?? '-' }}</td>
                                <td>{{ data.dtvalid !== null ? formatDate(data.dtvalid) : '-' }}</td>
                                <td>{{ data.palete ?? '-' }}</td>
                                <td>{{ data.endwms }}</td>
                                <td class="text-end">{{ formatDecimal(data.custoant) }}</td>
                                <td class="text-end">{{ formatDecimal(data.totalant) }}</td>
                                <td class="text-end">{{ formatDecimal(data.custo) }}</td>
                                <td class="text-end">{{ formatDecimal(data.totalentr) }}</td>
                                <td class="text-end">{{ formatDecimal(data.totalsaida) }}</td>
                                <td class="text-end">{{ formatDecimal(data.custoatu) }}</td>
                                <td class="text-end" v-if="flagDeleteProdutoSaldo !== null">
                                  <b-button variant="outline-danger" @click="deletarProdutoSaldo(data)" title="Deletar registro do histórico">
                                    <i class="bx bx-trash d-block font-size-16"></i>
                                  </b-button>
                                </td>
                              </tr>
                            </template>
                            <template v-else>
                              <tr>
                                <td colspan="19">
                                  <b-alert show dismissible variant="warning">
                                    <i class="mdi mdi-alert-outline me-2"></i>
                                    Sem registros de histórico de movimentação de saldo ou intervalo de data não inclui todas as movimentações!
                                  </b-alert>
                                </td>
                              </tr>
                            </template>
                          </tbody>
                        </table>
                      </div>


                    </div>
                  </div>
                </div>
              </div>
            </div>

          </b-card-text>
        </b-tab>



        <b-tab>
          <template v-slot:title>
            <i class="bx bx-camera d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Fotos</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div>
                  <h4 class="card-title">Multimídia do Produto</h4>
                  <!--                  <p class="card-title-desc">Favor fazer upload dos arquivos com as especificações.</p>-->

                  <div class="mt-4">

                    <div class="row">

                      <div class="col-md-3">
                        <label for="imgs">Imagem para listas (Máx: 200px x 200px) </label>
                        <div class="position-relative">
                          <input
                              id="imgs"
                              type="text"
                              v-model="produtoData.imgs"
                              class="form-control"
                              :disabled="true"
                              placeholder="Imagem para listas"/>
                        </div>
                      </div>


                      <div class="col-md-3">

                      </div>

                      <div class="col-md-3">
                        <label for="imgl">Imagem Grande (Máx: 1.200px x 1.200px) </label>
                        <div class="position-relative">
                          <input
                              id="imgl"
                              type="text"
                              v-model="produtoData.imgl"
                              class="form-control"
                              :disabled="true"
                              placeholder="Imagem grande"/>
                        </div>
                      </div>

                    </div>

                    <div class="row mt-2">

                      <div class="col-md-6" v-if="produtoData.imgSTrat">
                        <img
                            class="rounded me-2"
                            alt="200x200"
                            width="200"
                            @click="imgSmall = true"
                            :src="produtoData.imgSTrat"
                            data-holder-rendered="true"/>
                        <vue-easy-lightbox
                            :visible="imgSmall"
                            :imgs="produtoData.imgSTrat"
                            @hide="imgSmall = false">
                        </vue-easy-lightbox>
                      </div>

                      <div class="col-md-6" v-if="produtoData.imgLTrat">
                        <img
                            class="rounded me-2"
                            alt="1200x1200"
                            width="600"
                            @click="imgLarge = true"
                            :src="produtoData.imgLTrat"
                            data-holder-rendered="true"/>
                        <vue-easy-lightbox
                            :visible="imgLarge"
                            :imgs="produtoData.imgLTrat"
                            @hide="imgLarge = false">
                        </vue-easy-lightbox>
                      </div>

                    </div>


                    <div class="row mt-2">

                      <div class="table-responsive" v-if="!updating">
                        <table class="table align-middle mb-0 table-nowrap">
                          <thead class="table-light">
                          <tr>
                            <th scope="col">ID</th>
                            <th scope="col">Descrição</th>
                            <th scope="col">Arquivo</th>
                            <th scope="col">Data</th>
                            <th scope="col">Ações</th>
                          </tr>
                          </thead>
                          <tbody>

                          <tr v-for="data in mediasData" :key="data.id">

                            <td>
                              <h5 class="font-size-14 text-truncate">
                              <span class="text-dark">
                                {{ data.id }}
                              </span>
                              </h5>
                            </td>

                            <td>
                              {{ data.descricao }}
                            </td>

                            <td>
                        <span class="text-dark">
                          {{ data.nome }}
                        </span>
                            </td>

                            <td>
                              <h5 class="font-size-14 text-truncate">
                          <span class="text-dark">
                            {{ formatDateTime(data.created_at) }}
                          </span>
                              </h5>
                            </td>


                            <td>
                              <div class="button-items">

                                <b-button variant="outline-success" @click="downFile(data.path, data.nome)">
                                  <i class="mdi mdi-download d-block font-size-16"></i>
                                </b-button>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <i class="bx bx-bot d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Automações</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">

                    <h4 class="card-title mb-4">Robôs de Automação</h4>
                    <div class="row ">
                      <div class="col-sm-12">
                        <div class="text-end">
                          <button
                              @click="novoRobo"
                              class="btn btn-outline-info">
                            <i class="mdi mdi-plus me-1"></i> Nova Automação
                          </button>
                        </div>
                      </div>
                    </div>

                    <p class="card-title-desc">Entre com a URL de seus fornecedores / concorrentes</p>

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">URL</th>
                          <th scope="col">Tipo</th>
                          <th scope="col">Recorrência</th>
                          <th scope="col">Ações</th>
                        </tr>
                        </thead>
                        <tbody>


                        <tr v-for="data in gramposData" :key="data.id">

                          <td>
                            <h5 class="font-size-14 text-truncate">

                              <a href="javascript: void(0);" @click="editarGrampo(data.id)">
                                {{ data.url }}
                              </a>

                            </h5>
                            <p class="text-muted mb-0">{{  data.created_at }}</p>
                          </td>
                          <td> {{ data.tipo }}</td>
                          <td> {{ data.recurs }}</td>
                          <td>
                            <div class="button-items">
                              <b-button variant="outline-success" @click="editarGrampo(data.id)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>
                              <b-button variant="outline-danger" @click="deletarGrampo(data.id)">
                                <i class="mdi mdi-trash-can d-block font-size-16"></i>
                              </b-button>
                            </div>
                          </td>

                        </tr>


                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </b-card-text>
        </b-tab>

        <b-tab>
          <template v-slot:title>
            <i class="bx bx-money d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Tabelas de Preços</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Tabelas de Preços</h4>
                    <!--                    <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Tabela</th>
                          <th scope="col">Descrição</th>
                          <th scope="col">Data</th>
                          <th scope="col">Usuário</th>
                          <th scope="col">Status</th>

                          <th scope="col" class="text-end">Valor</th>
                          <th scope="col" class="text-end">Ações</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data in prodPrecosData" :key="data.id">

                          <td>
                            <a href="javascript: void(0);"
                               class="text-body fw-bold"
                               @click="selecionaProdPreco(data.id)">
                              {{ data.id }}
                            </a>
                          </td>

                          <td>
                            <a href="javascript: void(0);"
                               class="text-body fw-bold"
                               @click="selecionaProdPreco(data.id)">
                              {{ data.tabpreco }}
                            </a>
                          </td>

                          <td>{{ data.descricao }}</td>

                          <td>{{ formatDateTime(data.created_at) }}</td>
                          <td>{{ data.created_by }}</td>

                          <td>
                            <span
                                class="badge badge-pill badge-soft-success font-size-11"
                                :class="data.status === 'A' ? 'badge-soft-success' : 'badge-soft-danger'">
                              {{ nomeStatusTab(data.status)  }}
                            </span>
                          </td>

                          <td class="text-end">R$ {{ formatDecimal(data.preco) }}</td>


                          <td class="text-end">
                            <div class="button-items">

                              <b-button variant="outline-warning" @click="selecionaProdPreco(data.id)">
                                <i class="mdi mdi-pencil d-block font-size-16"></i>
                              </b-button>

                            </div>
                          </td>

                        </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </b-card-text>
        </b-tab>



        <b-tab>
          <template v-slot:title>
            <i class="bx bxs-user-detail d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Fornecedores</p>
          </template>
          <b-card-text>
            <div class="card">
              <div class="card-body">
                <div class="card shadow-none border mb-0">
                  <div class="card-body">
                    <h4 class="card-title mb-4">Fornecedores</h4>
                    <!--                    <p class="card-title-desc">Favor preencher corretamente os campos abaixo</p>-->

                    <div class="table-responsive">
                      <table class="table align-middle mb-0 table-nowrap">
                        <thead class="table-light">
                        <tr>
                          <th scope="col">ID</th>
                          <th scope="col">Fornecedor</th>
                          <th scope="col">Código</th>
                          <th scope="col">Data</th>
                        </tr>
                        </thead>
                        <tbody>

                        <tr v-for="data in prodFornecsData" :key="data.id">

                          <td>
                            <a href="javascript: void(0);"
                               class="text-body fw-bold">
                              {{ data.id }}
                            </a>
                          </td>

                          <td>
                            <a href="javascript: void(0);"
                               class="text-body fw-bold">
                              {{ data.nome }}
                            </a>
                          </td>

                          <td>{{ data.codigo }}</td>

                          <td>{{ formatDateTime(data.created_at) }}</td>


<!--                          <td class="text-end">-->
<!--                            <div class="button-items">-->

<!--                              <b-button variant="outline-warning" @click="selecionaProdPreco(data.id)">-->
<!--                                <i class="mdi mdi-pencil d-block font-size-16"></i>-->
<!--                              </b-button>-->

<!--                            </div>-->
<!--                          </td>-->

                        </tr>

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>


          </b-card-text>
        </b-tab>



        <b-tab>
          <template v-slot:title>
            <i class="bx bx-area d-block check-nav-icon mt-4 mb-2"></i>
            <p class="fw-bold mb-4">Categorias</p>
          </template>

          <DxTreeList id="prodCategs"
                      :data-source="prodCategsData"
                      :show-borders="true"
                      :column-auto-width="true"
                      :word-wrap-enabled="true"
                      :expanded-row-keys="expandedRowKeys"
                      :selected-row-keys="selectedRowKeys"
                      :auto-expand-all="true"
                      @row-dbl-click="onRowDblClick"
                      key-expr="id"
                      parent-id-expr="categpai_id">

            <DxScrolling mode="standard" />

            <DxSearchPanel :visible="false"
                           :width="250"/>
            <DxHeaderFilter :visible="true"/>
            <DxSelection mode="single"/>
            <DxColumnChooser :enabled="false"/>

            <DxColumn
                :width="300"
                caption="ID"
                data-field="id"/>

            <DxColumn
                :width="300"
                caption="Descrição"
                data-field="descricao"/>

            <DxColumn
                :min-width="100"
                data-field="status"
                caption="Status">
              <DxLookup :data-source="statuses"/>
            </DxColumn>


            <DxColumn data-field="created_at"
                      caption="Data"
                      data-type="date"/>

          </DxTreeList>



        </b-tab>

      </b-tabs>
    </div>


    <b-modal v-if="grampoData"
             :title="`${grampoData.id ? 'Editando Automação ' + grampoData.id : 'Criando Nova Automação (Robô)'}`"
             v-model="showModalGrampo"
             centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <!--          <label for="notatipo">Fornecedor encontrado com este CNPJ</label>-->
          <div >


          </div>


          <div class="row">

            <div class="col-md-12">
              <div class="mb-3">
                <label for="url">URL</label>

                <div class="position-relative">
                  <input
                      id="url"
                      v-model="grampoData.url"
                      type="text"
                      class="form-control"
                      placeholder="URL do site a varrer"
                      :class="{'is-invalid': submittedRobo && !grampoData.url }"/>
                  <div v-if="submittedRobo && !grampoData.url" class="invalid-feedback">
                    <span>Campo URL obrigatório, favor preencher.</span>
                  </div>
                  <div class="chat-input-links" v-if="grampoData.url">
                    <ul class="list-inline mb-0">
                      <li class="list-inline-item">
                        <a href="javascript: void(0);"
                           v-b-tooltip.hover
                           placement="top"
                           @click="testarUrl"
                           title="Testar URL">
                          <i class="mdi mdi-text-search"></i>
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="tipogrampo">Tipo</label>
                <select
                    id="tipogrampo"
                    v-model="grampoData.tipo"
                    class="form-control"
                    :class="{'is-invalid': submittedRobo && !grampoData.tipo}">
                  <option value="CO">Compras / Entrada</option>
                  <option value="VE">Vendas / Saídas</option>
                </select>
                <div v-if="submittedRobo && !grampoData.tipo" class="invalid-feedback">
                  <span>Campo tipo obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="recurs">Recorrência</label>
                <select
                    id="recurs"
                    v-model="grampoData.recurs"
                    class="form-control"
                    :class="{'is-invalid': submittedRobo && !grampoData.recurs}">
                  <option value="DI">Diário</option>
                  <option value="SE">Semanal</option>
                  <option value="ME">Mensal</option>
                </select>
                <div v-if="submittedRobo && !grampoData.recurs" class="invalid-feedback">
                  <span>Campo recorrência obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>

        </div>
      </div>


      <div >
        <div class="row mt-3 mb-3">
          <div class="col-md-6">
            <span class="text-primary">Status Automação </span>
            <b-form-checkbox

                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="grampoData.status">
              {{ grampoData.status === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>

          <div class="col-md-6">
            <span class="text-primary">Alertar Alteração </span>
            <b-form-checkbox

                switch size="lg"
                value="A"
                unchecked-value="I"
                v-model="grampoData.stsalerta">
              {{ grampoData.status === 'A' ? 'Ativo' : 'Inativo' }}
            </b-form-checkbox>
          </div>
        </div>
        <div class="table-responsive" >
          <table class="table table-centered table-nowrap">
            <thead>
            <tr>
              <th scope="col">Últimas Leituras</th>
              <th scope="col" class="text-end">Data</th>
              <th scope="col" class="text-end">Valor (R$)</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="data in cotacoesData" :key="data.id">
              <td>
                <div>
                  <h5 class="text-truncate font-size-14">
                    {{ formatDateTime(data.created_at) }}
                  </h5>
                </div>
              </td>
              <td class="text-end">{{ formatDecimal(data.valor) }}</td>
              <td class="text-end">{{ formatDecimal(data.valor) }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <div class="row text-center" v-if="updatingAutomacoes">
          <div class="col-12 text-center">
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
            <b-spinner type="grow"
                       class="m-6 mx-2"
                       variant="secondary"
                       role="status">
            </b-spinner>
          </div>
        </div>

        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalGrampo = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confGrampo">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>

      </div>

    </b-modal>



    <b-modal :title="`${prodPrecoData.id ? 'Editando Preço ' + prodPrecoData.id : 'Criando Novo Preço'}`"
             v-model="showModalPreco"
             centered hide-footer>

      <div class="col-md-12">
        <div class="mb-3">
          <!--          <label for="notatipo">Fornecedor encontrado com este CNPJ</label>-->
          <div >
          </div>

          <div class="row">
            <div class="col-md-12">
              <div class="mb-3">
                <span class="font-size-13">Tabela de Preço</span>
                <multiselect id="inputTabPreco"
                             @search-change="pesqTabPreco"
                             v-model="prodPrecoData.tabpreco"
                             placeholder="pesquisar tabela de preço..."
                             :options="dtListPesqTabPreco"
                             :searchable="true"
                             :style="submittedPreco && !prodPrecoData.tabpreco ? 'border: 1px solid #f86c6b !important;' : ''"
                             label="descricao"
                             track-by="descricao"
                             value-prop="codigo"
                             class="mt-2">
                  <template #option="slotProps">
                    <div style="min-width: 10%;">
                              <span class="text-info">
                                {{ slotProps.option.codigo }}
                              </span>
                    </div>
                    <div style="min-width: 250px;">
                              <span class="mx-4" >
                                {{ slotProps.option.descricao }}
                              </span>
                    </div>
                  </template>
                </multiselect>
                <div v-if="submittedPreco && !prodPrecoData.tabpreco">
                  <span class="text-danger font-size-11">Campo Tabela obrigatório, favor selecionar.</span>
                </div>
              </div>
            </div>

            <div class="col-md-6">
              <span class="text-primary">Status </span>
              <b-form-checkbox

                  switch size="lg"
                  value="A"
                  unchecked-value="I"
                  v-model="prodPrecoData.status">
                {{ prodPrecoData.status === 'A' ? 'Ativo' : 'Inativo' }}
              </b-form-checkbox>
            </div>

            <div class="col-md-6">
              <div class="mb-3">
                <label for="valor">Valor</label>
                <input
                    id="valor"
                    v-model="prodPrecoData.preco"
                    class="form-control"
                    type="number"
                    :class="{'is-invalid': submittedPreco && !prodPrecoData.preco}" />

                <div v-if="submittedPreco && !prodPrecoData.preco" class="invalid-feedback">
                  <span>Campo valor obrigatório, favor preencher.</span>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>

      <div>
        <div class="text-end mt-5">
          <b-button variant="light" @click="showModalPreco = false">
            <i class="bx bx-block font-size-16 align-middle me-2"></i>
            Cancelar
          </b-button>
          <b-button type="submit" variant="success" class="ms-1" @click="confPreco">
            <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
            Confirmar
          </b-button>
        </div>
      </div>

    </b-modal>


    <b-modal title="Atualizar Arquivo de Logomarca" v-model="showModalAtuImg" hide-footer>

      <!--        <h5 class="card-title">Favor selecionar os campos que deseja importar</h5>-->




      <div class="row">
        <div class="card-body">
          <h4 class="card-title">Selecionar novo arquivo</h4>
          <DropZone @change="selectedFile" />
          <span class="file-info">Arquivo: {{ dropzoneFile.name }}</span>
          <div v-if="submittedImagem && !dropzoneFile.name" >
            <span class="text-danger font-size-11">Favor selecionar o arquivo e tentar novamente.</span>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="mb-3">
            <label for="tipoestab">Tipo de Imagem</label>
            <select
                id="tipoestab"
                v-model="tipoUpload"
                class="form-control">
              <option value="peq">Pequena (Máximo: 200px x 200px)</option>
              <option value="grd">Grande (Máximo: 1.200px x 1.200px)</option>
              <!--              <option value="jpgdanfe">Danfe (JPG)</option>-->
            </select>
          </div>
        </div>
      </div>

      <div class="text-end mt-5">

        <div v-if="erroUpImagem !== ''" >
          <span class="text-danger font-size-11"> {{ erroUpImagem }} </span>
        </div>
      </div>


      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalAtuImg = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button :disabled="erroUpImagem !== ''"
                  type="submit"
                  variant="success"
                  class="ms-1"
                  @click="confAtuImagem">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>





    <b-modal v-model="showModalCriarCategoria"
             id="modalRenderHtml"
             size="md"
             title="Categorias de Produto"
             title-class="font-18"
             hide-footer>

      <div class="row mb-2 text-wrap">


        <div class="row mb-2">
          <div class="col-md-12">
            <div class="mb-3">
              <span class="font-size-13">Nova Categoria</span>
              <multiselect id="inputTabPreco"
                           @search-change="pesqCategoria"
                           v-model="prodcriacateg"
                           placeholder="pesquisar categorias..."
                           :options="dtListPesqCategoria"
                           :searchable="true"
                           :style="submittedCategoria && !prodcriacateg ? 'border: 1px solid #f86c6b !important;' : ''"
                           label="descricao"
                           track-by="descricao"
                           value-prop="id"
                           class="mt-2">
                <template #option="slotProps">
                  <div style="min-width: 10%;">
                              <span class="text-info">
                                {{ slotProps.option.id }}
                              </span>
                  </div>
                  <div style="min-width: 250px;">
                              <span class="mx-4" >
                                {{ slotProps.option.descricao }}
                              </span>
                  </div>
                </template>
              </multiselect>
              <div v-if="submittedCategoria && !prodcriacateg">
                <span class="text-danger font-size-11">Campo Categoria obrigatório, favor selecionar.</span>
              </div>
            </div>
          </div>
        </div>
        <div class="row mb-2">
          <div class="col-md-12">
            <div class="mb-3">
              <label for="prodcriacategpai">Associar a Categoria</label>
              <select
                  id="selectProdCategPai"
                  v-model="prodcriacategpai"
                  class="form-control select2-search-disable">
                <option v-for="categ in prodCategsData" :key="categ.id"
                        :value="categ.id">{{ categ.id }} - {{ categ.descricao }}
                </option>
              </select>
            </div>
          </div>
        </div>
      </div>


      <div class="d-flex justify-content-center">
        <b-button variant="success" @click="confNovaCategoria">Confirmar</b-button>
      </div>
    </b-modal>




    <b-modal v-model="showModalCriarComposicao"
             id="modalCriaComposicao"
             size="md"
             title="Composições para Produto"
             title-class="font-18"
             hide-footer>
      <div class="row mb-2 text-wrap">


        <div class="row mb-2">
          <div class="col-md-12">
            <div class="mb-3">
              <span class="font-size-13">Nova Composição</span>
              <multiselect id="produtoPesq"
                           ref="inputPesqProd"
                           @search-change="pesqProduto"
                           @select="escolheuProduto"
                           v-model="produtoPesqCompData"
                           placeholder="Pesquisar produto"
                           :options="dtlistPesqProduto || []"
                           :searchable="true"
                           :loading="loadingPesqProd"
                           label="descricao"
                           class="multiselect-size form-control bg-light border-light rounded"
                           track-by="descricao"
                           value-prop="id">
                <template #noOptions>
                  <span v-if="loadingPesqProd">Carregando Options...</span>
                  <span v-else>Nenhum resultado encontrado</span>
                </template>

                <template #option="slotProps" v-if="dtlistPesqProduto">
                  <div class="row" style="min-width: 100%;">

                    <div style="min-width: 100%;">
                      <span class="text-info">{{ slotProps.option.codigo }}</span>
                      <span class="mx-4" >{{ slotProps.option.unidade }}</span>
                      <span class="float-end text-warning">
                        R$ {{ formatDecimal(slotProps.option.preco) }}
                      </span>
                    </div>

                    <div class="col-12">
                      <span class="mt-5 font-size-15">{{ slotProps.option.descricao }}</span>
                    </div>

                    <div class="align-items-end text-end align-content-end float-end">
                      <div v-if="!slotProps.option.img1" class="avatar-xs">
                        <span class="avatar-title rounded-circle">{{ slotProps.option.id }}</span>
                      </div>
                      <div v-if="slotProps.option.img1">
                        <img class="rounded-circle avatar-xs" :src="slotProps.option.img1" alt />
                      </div>
                      <span class="float-end ">
                        <span v-if="slotProps.option.saldo > 0" class="avatar-title rounded-circle bg-success avatar-xs p-1">
                          <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                        </span>
                        <span v-else class="avatar-title rounded-circle bg-danger avatar-xs p-1">
                          <span class="">{{ formatInteger(slotProps.option.saldo) }}</span>
                        </span>
                      </span>
                    </div>

                  </div>
                </template>
              </multiselect>
              <div v-if="submittedComposicao && !produtoPesqCompData">
                <span class="text-danger font-size-11">Campo Composição obrigatório, favor preencner.</span>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-2">

          <div class="col-md-6 text-end">
            <label for="qtdcompos">Quantidade</label>
            <div class="position-relative">
              <input
                  id="qtdcompos"
                  ref="qtdcompos"
                  v-model="produtoQtdCompData"
                  type="number"
                  class="form-control text-end"
                  placeholder="Quantidade"
                  :class="{'is-invalid': submittedComposicao && produtoQtdCompData <= 0}"/>
              <div v-if="submittedComposicao && (!produtoQtdCompData  || produtoQtdCompData <= 0)"
                   class="invalid-feedback">
                <span> Campo quantidade deve ser maior que zero, favor preencher. </span>
              </div>
            </div>
          </div>

          <div class="col-sm-6">
            <div class="mb-3">
              <label for="fator">Fator</label>
              <select id="fator" v-model="produtoFatorCompData" class="form-control"
                      :class="{'is-invalid': submittedComposicao && !produtoFatorCompData}">
                <option value="*">Multiplicação (*)</option>
                <option value="/">Divisão (/)</option>
              </select>
              <div v-if="submittedComposicao && !produtoFatorCompData" class="invalid-feedback">
                <span>Campo fator obrigatório, favor preencher.</span>
              </div>
            </div>
          </div>

        </div>



      </div>


      <div class="d-flex justify-content-end mt-4">
        <b-button variant="success" @click="confNovaComposicao">Confirmar</b-button>
      </div>
    </b-modal>




    <b-modal v-model="showModalCriarVariacao"
             id="modalCriaVariacao"
             size="md"
             title="Variações do Produto"
             title-class="font-18"
             hide-footer>
      <div class="row mb-2 text-wrap">

        <div class="col-sm-12">
          <div class="mb-3">
            <label for="atributo">Atributo</label>
            <select
                id="atributo"
                v-model="produtoAtrVarData"
                @change="mudouAtribVar"
                class="form-control"
                :class="{ 'is-invalid': submittedVariacao && !produtoAtrVarData}">
              <option value="Cor">Cor</option>
              <option value="Tamanho">Tamanho</option>
              <option value="Largura">Largura</option>
              <option value="Voltagem">Voltagem</option>
            </select>
            <div v-if="submittedVariacao && !produtoAtrVarData"
                 class="invalid-feedback">
                <span> Campo Atributo obrigatório, favor preencher. </span>
            </div>
          </div>
        </div>

        <div class="col-sm-12">
          <div class="mb-3">
            <label for="opcao">Opção</label>
            <select
                id="opcao"
                v-model="produtoOpcaoVarData"
                class="form-control"
                :class="{ 'is-invalid': submittedVariacao && !produtoOpcaoVarData}">
              <option v-for="(item, index) in variacoesProdData"
                      :value="item.value"
                      :key="index">
                {{ item.value }}
              </option>
            </select>
            <div v-if="submittedVariacao && !produtoOpcaoVarData"
                 class="invalid-feedback">
              <span> Campo Opção obrigatório, favor preencher. </span>
            </div>
          </div>
        </div>


      </div>


      <div class="d-flex justify-content-end mt-4">
        <b-button variant="success" @click="confNovaVariacao">Confirmar</b-button>
      </div>
    </b-modal>


    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="tipooperacao">Selecionar Data Inicial e Final</label>

        </div>
      </div>
      <div class="row">

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>

        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>

      </div>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal  size="lg"
              :title="prodParamData.id != null ? `Editar Parâmetro (${ prodParamData.id })` : 'Criar Novo Parâmetro'"
              v-model="showFormProdParam" centered hide-footer>
      <div class="row" id="div-principal">
        <div class="row" id="div-card">
          <div class="card-body" id="div-car-body">

            <form class="needs-validation">

              <div class="row">

                <div class="col-sm-6">
                  <div class="mb-3">
                    <label for="valor">Valor <span class="text-muted">(obrigatório)</span></label>
                    <select id="valor" v-model="prodParamData.valor" class="form-control"
                            :disabled="prodParamData.id != null">
                      <option value="SKIP_CONF_LOTE">Não considerar lote</option>
                    </select>
                    <div v-if="!prodParamData.valor" class="invalid-feedback">
                      <span>Campo valor obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>


                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="codigo">Código <span class="text-muted">(Opcional)</span></label>
                    <input
                        id="codigo"
                        v-model="prodParamData.codigo"
                        type="text"
                        class="form-control"
                        placeholder="Código"/>
                  </div>
                </div>


                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="descricao">Descrição <span class="text-muted">(Opcional)</span></label>
                    <input
                        id="descricao"
                        v-model="prodParamData.descricao"
                        type="text"
                        class="form-control"
                        placeholder="Descrição"/>
                  </div>
                </div>


              </div>

              <div class="row">

                <div class="text-end mt-5">
                  <b-button variant="light" @click="showFormProdParam = false">
                    <i class="bx bx-block font-size-16 align-middle me-2"></i>
                    Cancelar
                  </b-button>
                  <b-button type="button" variant="success" class="ms-1" @click="confProdParam">
                    <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
                    Confirmar
                  </b-button>
                </div>
              </div>
            </form>

          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
        v-model="showModalHelpLote"
        id="showModalHelpLote"
        size="lg"
        title="Entendo a utilização de lote"
        title-class="font-18"
        hide-footer
    >
      <div class="row">
        <div class="col-xl-12">
          <div class="card">
            <div class="card-body">
              <p>Quando desativado, a validação de lote na movimentação/manuseio de saldo para esse item não será incluída</p>
            </div>
          </div>
        </div>
      </div>
    </b-modal>

    <b-modal
        v-model="showModalRemanejarSaldo"
        id="showModalHelpLote"
        size="lg"
        title="Remanejar estoque atual"
        title-class="font-18"
        hide-footer
    >
      <div class="row">
        <div class="col-md-4">
          <b-form-group
              class="mb-3"
              label="Endereço WMS"
          >
            <b-form-input
                type="text"
                readonly
                v-model="itemRemanejarRead.endwms"
            ></b-form-input>
          </b-form-group>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <b-form-group
                class="mb-3"
                label="Lote"
            >
              <b-form-input
                  type="text"
                  readonly
                  v-model="itemRemanejarRead.lote"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
        <div class="col-md-4">
          <div class="form-group">
            <b-form-group
                class="mb-3"
                label="Saldo"
            >
              <b-form-input
                  type="text"
                  readonly
                  v-model="itemRemanejarRead.saldo"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <label for="endereco">Selecionar novo endereço</label>

          <multiselect id="endereco"
                       @search-change="pesqEndereco"
                       @select="escolheuEndereco"
                       v-model="itemRemanejarWrite.endwms"
                       placeholder="Pesquisar endereços"
                       :options="dtlistPesqEndereco"
                       :searchable="true"
                       label="descricao"
                       track-by="descricao"
                       value-prop="descricao">
            <template #option="slotProps">
              <div class="row">
                <div>
                  <span class="text-info">
                    {{ slotProps.option.codigo }}
                  </span>
                  <span class="mx-4" >
                    {{ slotProps.option.endereco }}
                  </span>
                </div>
                <div class="mt-2 font-size-20">{{ slotProps.option.descricao }}</div>
                <span class="mx-4" >
                  </span>
                <div class="align-items-end text-end align-content-end">{{ formatDateTime(slotProps.option.created_at) }} </div>
              </div>
            </template>
          </multiselect>
        </div>

        <div class="col-md-4">
          <div class="form-group">
            <b-form-group
                class="mb-3"
                label="Quantidade"
            >
              <b-form-input
                  type="text"
                  v-model="itemRemanejarWrite.saldo"
              ></b-form-input>
            </b-form-group>
          </div>
        </div>
      </div>

      <div class="row mt-3" v-if="dtListNewEndRemanejar.length > 0">
        <div class="col-md-12">
          <h6>Endereço: {{itemRemanejarWrite.endwms}}</h6>

          <div class="table-scroll">
            <table class="table mb-0">
              <thead>
              <tr>
                <th>Produto</th>
                <th>Produto nome</th>
                <th>Lote</th>
                <th>Saldo</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="data in dtListNewEndRemanejar" :key="data.id">
                <td>{{data.produto}}</td>
                <td>{{data.descprod}}</td>
                <td>{{data.lote}}</td>
                <td>{{data.saldo}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="row mt-3" v-if="newEndValidado">
        <div class="col-md-12" v-if="dtListNewEndRemanejar.length === 0">
          <b-alert show variant="success">O endereço informado está livre para receber a transferência de saldo!</b-alert>
        </div>
      </div>

      <div class="row mt-3" v-else>
        <div class="col-md-12">
          <b-alert show variant="warning">Validação do novo endereço pendente!</b-alert>
        </div>
      </div>


      <div class="text-end mt-5">

        <b-button variant="light" @click="showModalRemanejarSaldo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>

        <b-button type="submit" variant="success" class="ms-1" @click="confirmarRemanejo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>


  </Layout>
</template>

<style scoped>
.table-scroll {
  max-height: 300px;
  overflow-y: auto;
}
</style>